import React, {
    useState,
    useRef,
    useContext, useEffect,
} from "react";

import { crudeDatabase } from "../data/crudeDatabase";
import { generateBlend } from "../engine/blendEngine";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import QRCode from "react-qr-code";
import Barcode from "react-barcode";

import "../components/LoadingReceipt.css";

import { ProcessContext } from "../context/ProcessContext";






function PreFlashLaboratory({ onClose }) {

    const [currentPage, setCurrentPage] = useState(0);



    const report =
        JSON.parse(
            localStorage.getItem("PREFLASH_REPORT")
        )
        ||
        {};

    const preflash =
        JSON.parse(
            localStorage.getItem("PREFLASH_REPORT")
        ) || {};





    const refineryFeed =
        JSON.parse(
            localStorage.getItem("ACTIVE_BLEND")
        ) || {};

    const operation =
        report.operation || {};

    const tower =
        report.tower || {};

    const overhead =
        report.overhead || {};

    const bottoms =
        report.bottoms || {};

    const performance =
        report.performance || {};




    const properties =
        refineryFeed.properties || {};



    const crudeAPI =
        Number(properties?.physicalProperties?.[7]?.value || 0);



    const OverheadComposition =
        JSON.parse(localStorage.getItem("PreFlashOverheadComposition")) || {};

    console.log("LAB OVERHEAD", OverheadComposition);

    const BottomsComposition =
        JSON.parse(localStorage.getItem("PreFlashBottomsComposition")) || {};

    console.log("LAB BOTTOMS", BottomsComposition);

    const BottomsFlowComposition =
        JSON.parse(localStorage.getItem("PreFlashBottomsFlowComposition")) || {};

    console.log("LAB BOTTOMS FLOW", BottomsFlowComposition);

    const preFlashOperation =
        JSON.parse(localStorage.getItem("PREFLASH_OPERATION")) || {};

    console.log("LAB PREFLASH REPORT", preflash);

    const {
        TotalFeed,
        NonHydrocarbonFeed,
        refluxRatio,
        waterRatio,
        steamBoost,
        vaporFraction,
        VaporGeneration,
        RefluxCooling

    } = preFlashOperation;



    const TT_16001 =
        preflash.feed?.temperature || 0;


    const PT_16001 =
        preflash.feed?.pressure || 0;



    const TT_16002 =
        tower.top?.temperature || 0;


    const PT_16002 =
        tower.top?.pressure || 0;



    const TT_16003 =
        tower.middle?.temperature || 0;


    const PT_16003 =
        tower.middle?.pressure || 0;



    const TT_16004 =
        tower.bottom?.temperature || 0;


    const PT_16004 =
        tower.bottom?.pressure || 0;



    const FIC_16009 =
        overhead.flow || 0;



    const FIC_16013 =
        bottoms.flow || 0;


    const TotalLightNaphtha =
        bottoms.flowComposition?.LightNaphtha || 0;


    const TotalHeavyNaphtha =
        bottoms.flowComposition?.HeavyNaphtha || 0;


    const TotalKerosene =
        bottoms.flowComposition?.Kerosene || 0;


    const TotalDiesel =
        bottoms.flowComposition?.Diesel || 0;


    const TotalVGO =
        bottoms.flowComposition?.VGO || 0;


    const TotalResidue =
        bottoms.flowComposition?.Residue || 0;

    const IBP =
        properties?.tbpDistillation?.[70]?.value || 0;




    const blendInfo =
        refineryFeed.blendInfo || {};

    const flowInfo =
        refineryFeed.flowInfo || {};

    const feedCrudes =
        refineryFeed.feedCrudes || {};




    const crudeDensity =
        Number(properties?.physicalProperties?.[9]?.value || 0);

    const sulfur =
        Number(properties?.bulkElementalComposition?.[3]?.value || 0);

    const tan =
        Number(properties?.corrosionStability?.[24]?.value || 0);


    const { transmitters } = usePlantStore();

    const FIC_16004 =
        transmitters.FIC_16004 || 0;





    const [position, setPosition] = useState({
        x: 120,
        y: 40
    });

    const [dragging, setDragging] = useState(false);

    const offsetRef = useRef({
        x: 0,
        y: 0
    });

    const startDrag = (e) => {

        setDragging(true);

        offsetRef.current = {

            x: e.clientX - position.x,

            y: e.clientY - position.y

        };

    };


    const handleMouseMove = (e) => {

        if (!dragging) return;

        setPosition({

            x: e.clientX - offsetRef.current.x,

            y: e.clientY - offsetRef.current.y

        });

    };


    const stopDrag = () => {

        setDragging(false);

    };



    useEffect(() => {

        window.addEventListener(
            "mousemove",
            handleMouseMove
        );

        window.addEventListener(
            "mouseup",
            stopDrag
        );

        return () => {

            window.removeEventListener(
                "mousemove",
                handleMouseMove
            );

            window.removeEventListener(
                "mouseup",
                stopDrag
            );

        };

    }, [dragging]);





    return (

        <div
            className="receipt-window"
            style={{
                left: position.x,
                top: position.y,
                width: "680px",
                height: "88vh",
                display: "flex",
                flexDirection: "column"
            }}
        >


            {/* HEADER */}

            <div
                className="receipt-header"
                onMouseDown={startDrag}
                style={{
                    cursor: "move"
                }}
            >

                <div>
                    NK TECH INDUSTRIAL DCS & DIGITAL TWIN SOLUTION
                </div>


                <button
                    className="receipt-close"
                    onClick={onClose}
                >
                    ✕
                </button>


            </div>





            <div className="receipt-scroll">

                {/* ==========================================
                    PAGE 0 - COVER PAGE
            ========================================== */}

                {currentPage === 0 && (

                    <div className="receipt-page">

                        <div
                            style={{
                                textAlign: "center",
                                marginBottom: 30
                            }}
                        >

                            <div
                                style={{
                                    fontSize: 18,
                                    fontWeight: "bold",
                                    color: "#003366",
                                    letterSpacing: 1
                                }}
                            >
                                NK TECH NIGERIA LIMITED
                            </div>

                            <div
                                style={{
                                    fontSize: 14,
                                    marginTop: 4,
                                    color: "#666"
                                }}
                            >
                                NK REFINERY DIGITAL TWIN SYSTEM
                            </div>

                            <div
                                style={{
                                    fontSize: 13,
                                    marginTop: 4,
                                    color: "#666"
                                }}
                            >
                                PROCESS SIMULATION • DIGITAL LABORATORY • OPERATIONS MONITORING
                            </div>

                        </div>

                        <hr />

                        <div
                            style={{
                                textAlign: "center",
                                margin: "30px 0"
                            }}
                        >

                            <h1
                                style={{
                                    margin: 0,
                                    fontSize: 34,
                                    color: "#0B4F9C",
                                    letterSpacing: 2
                                }}
                            >
                                PRE-FLASH TOWER
                            </h1>

                            <h2
                                style={{
                                    marginTop: 10,
                                    marginBottom: 8,
                                    color: "#444",
                                    fontWeight: 600
                                }}
                            >
                                PROCESS LABORATORY REPORT
                            </h2>

                            <div
                                style={{
                                    fontSize: 17,
                                    fontWeight: "bold",
                                    color: "#666"
                                }}
                            >
                                ATMOSPHERIC DISTILLATION UNIT (ADU)
                            </div>

                            <div
                                style={{
                                    marginTop: 10,
                                    fontSize: 13,
                                    color: "#888"
                                }}
                            >
                                Equipment Tag : T-101
                            </div>

                        </div>

                        <hr />

                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: 20,
                                marginTop: 25,
                                marginBottom: 25
                            }}
                        >

                            <div
                                style={{
                                    border: "1px solid #bbb",
                                    borderRadius: 8,
                                    padding: 15,
                                    background: "#fafafa"
                                }}
                            >

                                <h3
                                    style={{
                                        marginTop: 0,
                                        color: "#0B4F9C"
                                    }}
                                >
                                    REPORT INFORMATION
                                </h3>

                                <table className="receipt-table">

                                    <tbody>

                                        <tr>

                                            <td><strong>Report No.</strong></td>

                                            <td>{report.reportNumber}</td>

                                        </tr>

                                        <tr>

                                            <td><strong>Date</strong></td>

                                            <td>{report.generated}</td>

                                        </tr>

                                        <tr>

                                            <td><strong>Status</strong></td>

                                            <td
                                                style={{
                                                    color: "green",
                                                    fontWeight: "bold"
                                                }}
                                            >
                                                ONLINE
                                            </td>

                                        </tr>

                                        <tr>

                                            <td><strong>Laboratory</strong></td>

                                            <td>Process Simulation</td>

                                        </tr>

                                        <tr>

                                            <td><strong>Equipment</strong></td>

                                            <td>Pre-Flash Tower (T-101)</td>

                                        </tr>

                                    </tbody>

                                </table>

                            </div>

                            <div
                                style={{
                                    border: "1px solid #bbb",
                                    borderRadius: 8,
                                    padding: 15,
                                    background: "#fafafa"
                                }}
                            >

                                <h3
                                    style={{
                                        marginTop: 0,
                                        color: "#0B4F9C"
                                    }}
                                >
                                    CURRENT PROCESS STATUS
                                </h3>

                                <table className="receipt-table">

                                    <tbody>

                                        <tr>

                                            <td>Feed Available</td>

                                            <td
                                                style={{
                                                    color: "green",
                                                    fontWeight: "bold"
                                                }}
                                            >
                                                ● YES
                                            </td>

                                        </tr>

                                        <tr>

                                            <td>Tower Status</td>

                                            <td
                                                style={{
                                                    color: "green",
                                                    fontWeight: "bold"
                                                }}
                                            >
                                                ● RUNNING
                                            </td>

                                        </tr>

                                        <tr>

                                            <td>Material Balance</td>

                                            <td
                                                style={{
                                                    color: "green",
                                                    fontWeight: "bold"
                                                }}
                                            >
                                                ● NORMAL
                                            </td>

                                        </tr>

                                        <tr>

                                            <td>Simulation</td>

                                            <td
                                                style={{
                                                    color: "green",
                                                    fontWeight: "bold"
                                                }}
                                            >
                                                ● ACTIVE
                                            </td>

                                        </tr>

                                        <tr>

                                            <td>Data Source</td>

                                            <td>Live Digital Twin</td>

                                        </tr>

                                    </tbody>

                                </table>

                            </div>

                        </div>

                        {/* ==========================================
        FEED INFORMATION
========================================== */}

                        <h3
                            className="section-title"
                            style={{ marginTop: 20 }}
                        >
                            FEED INFORMATION
                        </h3>

                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td><strong>Blend Name</strong></td>

                                    <td>{blendInfo.blendName}</td>

                                    <td><strong>Blend Grade</strong></td>

                                    <td>{blendInfo.blendGrade}</td>

                                </tr>

                                <tr>

                                    <td><strong>Feed Flow</strong></td>

                                    <td>
                                        {preflash.feed?.flow?.toFixed?.(3)} BPM
                                    </td>

                                    <td><strong>Feed Temperature</strong></td>

                                    <td>
                                        {preflash.feed?.temperature?.toFixed?.(2)} °C
                                    </td>

                                </tr>

                                <tr>

                                    <td><strong>Feed Pressure</strong></td>

                                    <td>
                                        {preflash.feed?.pressure?.toFixed?.(3)} MPa
                                    </td>

                                    <td><strong>API Gravity</strong></td>

                                    <td>
                                        {Number(properties?.physicalProperties?.[7]?.value || 0).toFixed(2)} °API
                                    </td>

                                </tr>

                                <tr>

                                    <td><strong>Density</strong></td>

                                    <td>
                                        {properties?.physicalProperties?.[9]?.value}
                                        {" "}
                                        {properties?.physicalProperties?.[9]?.unit}
                                    </td>

                                    <td><strong>Sulfur</strong></td>

                                    <td>
                                        {properties?.bulkElementalComposition?.[3]?.value}
                                        {" "}
                                        {properties?.bulkElementalComposition?.[3]?.unit}
                                    </td>

                                </tr>

                                <tr>

                                    <td><strong>Total Acid Number</strong></td>

                                    <td>
                                        {properties?.corrosionStability?.[24]?.value}
                                        {" "}
                                        {properties?.corrosionStability?.[24]?.unit}
                                    </td>

                                    <td><strong>Feed Type</strong></td>

                                    <td>
                                        {blendInfo?.blendName || "Unknown Blend"}
                                        {" "}
                                        (
                                        {blendInfo?.blendGrade || "UNKNOWN"}
                                        )
                                    </td>

                                </tr>

                            </tbody>

                        </table>

                        <br />

                        {/* ==========================================
        FEED CONTRIBUTORS
========================================== */}

                        <h3 className="section-title">

                            FEED CONTRIBUTORS

                        </h3>

                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>Crude</th>

                                    <th>Flow (BPM)</th>

                                    <th>Contribution</th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr>

                                    <td>

                                        {feedCrudes.crude1?.name}

                                    </td>

                                    <td>

                                        {flowInfo.crude1Flow?.toFixed?.(3)}

                                    </td>

                                    <td>

                                        {(flowInfo.ratio1 * 100)?.toFixed?.(2)} %

                                    </td>

                                </tr>

                                <tr>

                                    <td>

                                        {feedCrudes.crude2?.name}

                                    </td>

                                    <td>

                                        {flowInfo.crude2Flow?.toFixed?.(3)}

                                    </td>

                                    <td>

                                        {(flowInfo.ratio2 * 100)?.toFixed?.(2)} %

                                    </td>

                                </tr>

                                <tr
                                    style={{
                                        fontWeight: "bold",
                                        background: "#f0f5ff"
                                    }}
                                >

                                    <td>TOTAL</td>

                                    <td>

                                        {flowInfo.totalFlow?.toFixed?.(3)}

                                    </td>

                                    <td>

                                        100 %

                                    </td>

                                </tr>

                            </tbody>

                        </table>

                        <br />

                        {/* ==========================================
        BLEND QUALITY SNAPSHOT
========================================== */}

                        <h3 className="section-title">

                            BLEND QUALITY SNAPSHOT

                        </h3>

                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns:
                                    "repeat(4,1fr)",
                                gap: 18,
                                marginTop: 15
                            }}
                        >

                            <div
                                style={{
                                    border: "1px solid #ccc",
                                    borderRadius: 8,
                                    padding: 18,
                                    textAlign: "center",
                                    background: "#fdfdfd"
                                }}
                            >

                                <div
                                    style={{
                                        fontSize: 13,
                                        color: "#666"
                                    }}
                                >
                                    API GRAVITY
                                </div>

                                <div
                                    style={{
                                        fontSize: 28,
                                        fontWeight: "bold",
                                        color: "#0B4F9C"
                                    }}
                                >
                                    {Number(properties?.physicalProperties?.[7]?.value || 0).toFixed(2)}
                                </div>

                                <div>°API</div>

                            </div>

                            <div
                                style={{
                                    border: "1px solid #ccc",
                                    borderRadius: 8,
                                    padding: 18,
                                    textAlign: "center",
                                    background: "#fdfdfd"
                                }}
                            >

                                <div
                                    style={{
                                        fontSize: 13,
                                        color: "#666"
                                    }}
                                >
                                    DENSITY
                                </div>

                                <div
                                    style={{
                                        fontSize: 28,
                                        fontWeight: "bold",
                                        color: "#0B4F9C"
                                    }}
                                >
                                    {Number(
                                        properties?.physicalProperties?.[9]?.value || 0
                                    ).toFixed(1)}
                                </div>

                                <div>kg/m³</div>

                            </div>

                            <div
                                style={{
                                    border: "1px solid #ccc",
                                    borderRadius: 8,
                                    padding: 18,
                                    textAlign: "center",
                                    background: "#fdfdfd"
                                }}
                            >

                                <div
                                    style={{
                                        fontSize: 13,
                                        color: "#666"
                                    }}
                                >
                                    SULFUR
                                </div>

                                <div
                                    style={{
                                        fontSize: 28,
                                        fontWeight: "bold",
                                        color: "#0B4F9C"
                                    }}
                                >
                                    {Number(
                                        properties?.bulkElementalComposition?.[3]?.value || 0
                                    ).toFixed(3)}
                                </div>

                                <div>wt%</div>

                            </div>

                            <div
                                style={{
                                    border: "1px solid #ccc",
                                    borderRadius: 8,
                                    padding: 18,
                                    textAlign: "center",
                                    background: "#fdfdfd"
                                }}
                            >

                                <div
                                    style={{
                                        fontSize: 13,
                                        color: "#666"
                                    }}
                                >
                                    TAN
                                </div>

                                <div
                                    style={{
                                        fontSize: 28,
                                        fontWeight: "bold",
                                        color: "#0B4F9C"
                                    }}
                                >
                                    {Number(
                                        properties?.corrosionStability?.[24]?.value || 0
                                    ).toFixed(3)}
                                </div>

                                <div>mg KOH/g</div>

                            </div>

                        </div>

                        <br />


                        {/* ==========================================
        LABORATORY INTERPRETATION
========================================== */}

                        <h3 className="section-title">
                            LABORATORY INTERPRETATION
                        </h3>

                        <div
                            style={{
                                border: "1px solid #cccccc",
                                borderRadius: 8,
                                padding: 20,
                                background: "#fafafa",
                                lineHeight: 1.8,
                                textAlign: "justify"
                            }}
                        >

                            <p>

                                The blended crude feed entering the Pre-Flash Tower is classified as a
                                <strong> {blendInfo.blendGrade}</strong> crude oil with an API Gravity of
                                <strong> {Number(properties?.physicalProperties?.[7]?.value || 0).toFixed(2)} °API </strong>.

                                The measured sulfur content of
                                <strong>
                                    {Number(
                                        properties?.bulkElementalComposition?.[3]?.value || 0
                                    ).toFixed(3)} wt%
                                </strong>
                                indicates a relatively clean feed suitable for atmospheric
                                distillation with reduced corrosion tendency.

                            </p>

                            <p>

                                The laboratory evaluation indicates that the feedstock is expected to
                                produce stable vaporization, efficient light naphtha recovery,
                                improved furnace efficiency, reduced flash-zone loading and better
                                fractionation performance in the downstream Atmospheric Distillation Unit.

                            </p>

                        </div>

                        <br />

                        {/* ==========================================
        OPERATIONAL RECOMMENDATION
========================================== */}

                        <h3 className="section-title">
                            OPERATIONAL RECOMMENDATION
                        </h3>

                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>Item</th>

                                    <th>Recommendation</th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr>

                                    <td>Feed Quality</td>

                                    <td>
                                        Suitable for continuous processing.
                                    </td>

                                </tr>

                                <tr>

                                    <td>Pre-Flash Operation</td>

                                    <td>
                                        Maintain stable feed temperature and reflux ratio for optimum
                                        light-end separation.
                                    </td>

                                </tr>

                                <tr>

                                    <td>Corrosion Risk</td>

                                    <td>
                                        Low under current feed composition.
                                    </td>

                                </tr>

                                <tr>

                                    <td>Overall Assessment</td>

                                    <td
                                        style={{
                                            color: "green",
                                            fontWeight: "bold"
                                        }}
                                    >
                                        ACCEPTABLE FOR PROCESSING
                                    </td>

                                </tr>

                            </tbody>

                        </table>

                        <br />

                        {/* ==========================================
        DISCLAIMER
========================================== */}

                        <div
                            style={{
                                border: "1px solid #d8d8d8",
                                padding: 15,
                                borderRadius: 8,
                                background: "#fffef7"
                            }}
                        >

                            <strong>DISCLAIMER</strong>

                            <p
                                style={{
                                    marginTop: 10,
                                    lineHeight: 1.7,
                                    textAlign: "justify"
                                }}
                            >

                                This laboratory report was automatically generated by the
                                NK Refinery Digital Twin Process Laboratory Engine.

                                All laboratory values are obtained from the refinery process
                                simulation engine and are intended for process monitoring,
                                engineering analysis, operator training and educational purposes.

                                This report does not replace certified laboratory analysis.

                            </p>

                        </div>

                        <br />

                        {/* ==========================================
        DIGITAL AUTHENTICATION
========================================== */}

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginTop: 30
                            }}
                        >

                            <div>

                                <QRCode
                                    value={report.reportNumber || "PF"}
                                    size={110}
                                />

                                <div
                                    style={{
                                        marginTop: 8,
                                        fontSize: 12,
                                        textAlign: "center"
                                    }}
                                >
                                    Verification QR Code
                                </div>

                            </div>

                            <div
                                style={{
                                    textAlign: "center"
                                }}
                            >

                                <Barcode
                                    value={report.reportNumber || "PF"}
                                    width={1.6}
                                    height={45}
                                    fontSize={12}
                                />

                                <div
                                    style={{
                                        marginTop: 8,
                                        fontSize: 12
                                    }}
                                >
                                    Digital Authentication
                                </div>

                            </div>

                        </div>

                        <br />

                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: 40,
                                marginTop: 40
                            }}
                        >

                            <div>

                                ___________________________

                                <br />

                                <strong>Digital Laboratory Engineer</strong>

                            </div>

                            <div>

                                ___________________________

                                <br />

                                <strong>Operations Supervisor</strong>

                            </div>

                        </div>


                    </div>

                )}

                {/* ==========================================
                    PAGE 1
            ========================================== */}

                {currentPage === 1 && (

                    <div>

                        {/* ==========================================
        PAGE HEADER
========================================== */}

                        <h1 className="receipt-title">

                            PRE-FLASH TOWER FEED CHARACTERIZATION

                        </h1>


                        <h2 className="receipt-subtitle">

                            BLENDED CRUDE LABORATORY ANALYSIS

                        </h2>


                        <hr />



                        {/* ==========================================
        FEED IDENTIFICATION
========================================== */}


                        <h3 className="section-title">

                            FEED IDENTIFICATION

                        </h3>


                        <table className="receipt-table">

                            <tbody>


                                <tr>

                                    <td>
                                        <strong>Blend Name</strong>
                                    </td>

                                    <td>
                                        {blendInfo.blendName}
                                    </td>


                                    <td>
                                        <strong>Blend Grade</strong>
                                    </td>

                                    <td>
                                        {blendInfo.blendGrade}
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        <strong>Total Feed Flow</strong>
                                    </td>

                                    <td>
                                        {flowInfo.totalFlow?.toFixed?.(3)} BPM
                                    </td>


                                    <td>
                                        <strong>Status</strong>
                                    </td>

                                    <td>
                                        PRE-FLASH FEED
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        <strong>Feed Temperature</strong>
                                    </td>

                                    <td>
                                        {preflash.feed?.temperature?.toFixed?.(2)} °C
                                    </td>


                                    <td>
                                        <strong>Feed Pressure</strong>
                                    </td>

                                    <td>
                                        {preflash.feed?.pressure?.toFixed?.(3)} MPa
                                    </td>

                                </tr>


                            </tbody>

                        </table>


                        <br />



                        {/* ==========================================
        PHYSICAL PROPERTIES
========================================== */}



                        <h3 className="section-title">

                            PHYSICAL PROPERTIES

                        </h3>


                        <table className="receipt-table">


                            <thead>

                                <tr>

                                    <th>
                                        Property
                                    </th>

                                    <th>
                                        Value
                                    </th>

                                    <th>
                                        Unit
                                    </th>

                                </tr>

                            </thead>


                            <tbody>


                                <tr>

                                    <td>
                                        API Gravity @60°F
                                    </td>

                                    <td>
                                        {
                                            properties?.physicalProperties?.[7]?.value
                                        }
                                    </td>

                                    <td>
                                        °API
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Density @15°C
                                    </td>

                                    <td>
                                        {
                                            properties?.physicalProperties?.[9]?.value
                                        }
                                    </td>

                                    <td>
                                        kg/m³
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Viscosity @40°C
                                    </td>

                                    <td>
                                        {
                                            properties?.physicalProperties?.[11]?.value
                                        }
                                    </td>

                                    <td>
                                        cSt
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Viscosity @100°C
                                    </td>

                                    <td>
                                        {
                                            properties?.physicalProperties?.[12]?.value
                                        }
                                    </td>

                                    <td>
                                        cSt
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Pour Point
                                    </td>

                                    <td>
                                        {
                                            properties?.physicalProperties?.[13]?.value
                                        }
                                    </td>

                                    <td>
                                        °C
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Flash Point
                                    </td>

                                    <td>
                                        {
                                            properties?.physicalProperties?.[14]?.value
                                        }
                                    </td>

                                    <td>
                                        °C
                                    </td>

                                </tr>


                            </tbody>


                        </table>



                        <br />



                        {/* ==========================================
        ELEMENTAL COMPOSITION
========================================== */}



                        <h3 className="section-title">

                            ELEMENTAL COMPOSITION

                        </h3>



                        <table className="receipt-table">


                            <thead>

                                <tr>

                                    <th>
                                        Component
                                    </th>

                                    <th>
                                        Value
                                    </th>

                                    <th>
                                        Unit
                                    </th>

                                </tr>


                            </thead>



                            <tbody>


                                <tr>

                                    <td>
                                        Carbon (C)
                                    </td>

                                    <td>
                                        {
                                            properties?.bulkElementalComposition?.[1]?.value
                                        }
                                    </td>

                                    <td>
                                        wt%
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Hydrogen (H)
                                    </td>

                                    <td>
                                        {
                                            properties?.bulkElementalComposition?.[2]?.value
                                        }
                                    </td>

                                    <td>
                                        wt%
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Sulfur (S)
                                    </td>

                                    <td>
                                        {
                                            properties?.bulkElementalComposition?.[3]?.value
                                        }
                                    </td>

                                    <td>
                                        wt%
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Nitrogen (N)
                                    </td>

                                    <td>
                                        {
                                            properties?.bulkElementalComposition?.[4]?.value
                                        }
                                    </td>

                                    <td>
                                        wt%
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Oxygen (O)
                                    </td>

                                    <td>
                                        {
                                            properties?.bulkElementalComposition?.[5]?.value
                                        }
                                    </td>

                                    <td>
                                        wt%
                                    </td>

                                </tr>


                            </tbody>


                        </table>



                    </div>

                )}

                {/* ==========================================
                    PAGE 2
            ========================================== */}

                {currentPage === 2 && (

                    <div>

                        {/* ==========================================
        PAGE HEADER
========================================== */}

                        <h1 className="receipt-title">

                            TBP DISTILLATION ANALYSIS

                        </h1>


                        <h2 className="receipt-subtitle">

                            TRUE BOILING POINT CHARACTERIZATION

                        </h2>


                        <hr />


                        {/* ==========================================
        TBP DISTILLATION TABLE
========================================== */}


                        <h3 className="section-title">

                            TRUE BOILING POINT PROFILE

                        </h3>



                        <table className="receipt-table">


                            <thead>

                                <tr>

                                    <th>
                                        Cut Point
                                    </th>

                                    <th>
                                        Temperature
                                    </th>

                                    <th>
                                        Unit
                                    </th>

                                </tr>

                            </thead>



                            <tbody>

                                <tr>
                                    <td>Initial Boiling Point (IBP)</td>
                                    <td>{properties?.tbpDistillation?.[70]?.value}</td>
                                    <td>°C</td>
                                </tr>

                                <tr>
                                    <td>5% Recovery</td>
                                    <td>{properties?.tbpDistillation?.[71]?.value}</td>
                                    <td>°C</td>
                                </tr>

                                <tr>
                                    <td>10% Recovery</td>
                                    <td>{properties?.tbpDistillation?.[72]?.value}</td>
                                    <td>°C</td>
                                </tr>

                                <tr>
                                    <td>20% Recovery</td>
                                    <td>{properties?.tbpDistillation?.[73]?.value}</td>
                                    <td>°C</td>
                                </tr>

                                <tr>
                                    <td>30% Recovery</td>
                                    <td>{properties?.tbpDistillation?.[74]?.value}</td>
                                    <td>°C</td>
                                </tr>

                                <tr>
                                    <td>40% Recovery</td>
                                    <td>{properties?.tbpDistillation?.[75]?.value}</td>
                                    <td>°C</td>
                                </tr>

                                <tr>
                                    <td>50% Recovery</td>
                                    <td>{properties?.tbpDistillation?.[76]?.value}</td>
                                    <td>°C</td>
                                </tr>

                                <tr>
                                    <td>60% Recovery</td>
                                    <td>{properties?.tbpDistillation?.[77]?.value}</td>
                                    <td>°C</td>
                                </tr>

                                <tr>
                                    <td>70% Recovery</td>
                                    <td>{properties?.tbpDistillation?.[78]?.value}</td>
                                    <td>°C</td>
                                </tr>

                                <tr>
                                    <td>80% Recovery</td>
                                    <td>{properties?.tbpDistillation?.[79]?.value}</td>
                                    <td>°C</td>
                                </tr>

                                <tr>
                                    <td>90% Recovery</td>
                                    <td>{properties?.tbpDistillation?.[80]?.value}</td>
                                    <td>°C</td>
                                </tr>

                                <tr>
                                    <td>95% Recovery</td>
                                    <td>{properties?.tbpDistillation?.[81]?.value}</td>
                                    <td>°C</td>
                                </tr>

                                <tr>
                                    <td>Final Boiling Point (FBP)</td>
                                    <td>{properties?.tbpDistillation?.[82]?.value}</td>
                                    <td>°C</td>
                                </tr>

                            </tbody>

                        </table>


                        <br />



                        {/* ==========================================
        CUT YIELD DISTRIBUTION
========================================== */}


                        <h3 className="section-title">

                            PRODUCT CUT YIELD DISTRIBUTION

                        </h3>



                        <table className="receipt-table">


                            <thead>

                                <tr>

                                    <th>
                                        Fraction
                                    </th>

                                    <th>
                                        Yield
                                    </th>

                                    <th>
                                        Unit
                                    </th>

                                </tr>

                            </thead>



                            <tbody>


                                <tr>

                                    <td>
                                        LPG
                                    </td>

                                    <td>
                                        {
                                            properties?.cutYields?.LPG?.yieldWt?.value
                                        }
                                    </td>

                                    <td>
                                        wt%
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Light Naphtha
                                    </td>

                                    <td>
                                        {
                                            properties?.cutYields?.LightNaphtha?.yieldWt?.value
                                        }
                                    </td>

                                    <td>
                                        wt%
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Heavy Naphtha
                                    </td>

                                    <td>
                                        {
                                            properties?.cutYields?.HeavyNaphtha?.yieldWt?.value
                                        }
                                    </td>

                                    <td>
                                        wt%
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Kerosene
                                    </td>

                                    <td>
                                        {
                                            properties?.cutYields?.Kerosene?.yieldWt?.value
                                        }
                                    </td>

                                    <td>
                                        wt%
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Diesel
                                    </td>

                                    <td>
                                        {
                                            properties?.cutYields?.Diesel?.yieldWt?.value
                                        }
                                    </td>

                                    <td>
                                        wt%
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Vacuum Gas Oil (VGO)
                                    </td>

                                    <td>
                                        {
                                            properties?.cutYields?.VGO?.yieldWt?.value
                                        }
                                    </td>

                                    <td>
                                        wt%
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Residue
                                    </td>

                                    <td>
                                        {
                                            properties?.cutYields?.Residue?.yieldWt?.value
                                        }
                                    </td>

                                    <td>
                                        wt%
                                    </td>

                                </tr>


                            </tbody>


                        </table>



                        <br />



                        {/* ==========================================
        PRE-FLASH EXPECTED SEPARATION
========================================== */}


                        <h3 className="section-title">

                            EXPECTED PRE-FLASH SEPARATION

                        </h3>



                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>
                                        Component
                                    </th>

                                    <th>
                                        Overhead Removal
                                    </th>

                                    <th>
                                        Bottoms Remaining
                                    </th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr>

                                    <td>
                                        Light Naphtha
                                    </td>

                                    <td>
                                        {
                                            Number(
                                                overhead.composition?.LightNaphtha || 0
                                            ).toFixed(2)
                                        }
                                        %
                                    </td>

                                    <td>
                                        {
                                            Number(
                                                bottoms.composition?.LightNaphtha || 0
                                            ).toFixed(2)
                                        }
                                        %
                                    </td>

                                </tr>

                                <tr>

                                    <td>
                                        Heavy Naphtha
                                    </td>

                                    <td>
                                        {
                                            Number(
                                                overhead.composition?.HeavyNaphtha || 0
                                            ).toFixed(2)
                                        }
                                        %
                                    </td>

                                    <td>
                                        {
                                            Number(
                                                bottoms.composition?.HeavyNaphtha || 0
                                            ).toFixed(2)
                                        }
                                        %
                                    </td>

                                </tr>

                                <tr>

                                    <td>
                                        Kerosene
                                    </td>

                                    <td>
                                        {
                                            Number(
                                                overhead.composition?.Kerosene || 0
                                            ).toFixed(2)
                                        }
                                        %
                                    </td>

                                    <td>
                                        {
                                            Number(
                                                bottoms.composition?.Kerosene || 0
                                            ).toFixed(2)
                                        }
                                        %
                                    </td>

                                </tr>

                                <tr>

                                    <td>
                                        Diesel
                                    </td>

                                    <td>
                                        {
                                            Number(
                                                overhead.composition?.Diesel || 0
                                            ).toFixed(2)
                                        }
                                        %
                                    </td>

                                    <td>
                                        {
                                            Number(
                                                bottoms.composition?.Diesel || 0
                                            ).toFixed(2)
                                        }
                                        %
                                    </td>

                                </tr>

                                <tr>

                                    <td>
                                        VGO
                                    </td>

                                    <td>
                                        {
                                            Number(
                                                overhead.composition?.VGO || 0
                                            ).toFixed(2)
                                        }
                                        %
                                    </td>

                                    <td>
                                        {
                                            Number(
                                                bottoms.composition?.VGO || 0
                                            ).toFixed(2)
                                        }
                                        %
                                    </td>

                                </tr>

                                <tr>

                                    <td>
                                        Residue
                                    </td>

                                    <td>
                                        {
                                            Number(
                                                overhead.composition?.Residue || 0
                                            ).toFixed(2)
                                        }
                                        %
                                    </td>

                                    <td>
                                        {
                                            Number(
                                                bottoms.composition?.Residue || 0
                                            ).toFixed(2)
                                        }
                                        %
                                    </td>

                                </tr>

                            </tbody>

                        </table>



                    </div>

                )}



                {currentPage === 3 && (

                    <div>


                        {/* ==========================================
        PAGE HEADER
========================================== */}

                        <h1 className="receipt-title">

                            PRE-FLASH TOWER OPERATING CONDITIONS

                        </h1>


                        <h2 className="receipt-subtitle">

                            PROCESS PERFORMANCE AND SEPARATION PARAMETERS

                        </h2>


                        <hr />



                        {/* ==========================================
        FEED OPERATING CONDITIONS
========================================== */}


                        <h3 className="section-title">

                            FEED OPERATING CONDITIONS

                        </h3>



                        <table className="receipt-table">


                            <thead>

                                <tr>

                                    <th>
                                        Parameter
                                    </th>

                                    <th>
                                        Value
                                    </th>

                                    <th>
                                        Unit
                                    </th>

                                </tr>

                            </thead>



                            <tbody>


                                <tr>

                                    <td>
                                        Crude Feed Flow
                                    </td>

                                    <td>
                                        {
                                            Number(preflash.feed?.flow || 0)
                                                .toFixed(3)
                                        }
                                    </td>
                                    <td>
                                        BPM
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Non-Hydrocarbon Injection
                                    </td>

                                    <td>
                                        {
                                            Number(NonHydrocarbonFeed || 0)
                                                .toFixed(3)
                                        }
                                    </td>

                                    <td>
                                        BPM
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Total Feed Flow
                                    </td>

                                    <td>
                                        {
                                            Number(TotalFeed || 0)
                                                .toFixed(3)
                                        }
                                    </td>

                                    <td>
                                        BPM
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Feed Temperature
                                    </td>

                                    <td>
                                        {
                                            Number(TT_16001 || 0)
                                                .toFixed(2)
                                        }
                                    </td>

                                    <td>
                                        °C
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Feed Pressure
                                    </td>

                                    <td>
                                        {
                                            Number(PT_16001 || 0)
                                                .toFixed(3)
                                        }
                                    </td>

                                    <td>
                                        MPa
                                    </td>

                                </tr>



                            </tbody>


                        </table>



                        <br />



                        {/* ==========================================
        FLASHING PERFORMANCE
========================================== */}



                        <h3 className="section-title">

                            FLASHING PERFORMANCE

                        </h3>



                        <table className="receipt-table">


                            <thead>

                                <tr>

                                    <th>
                                        Parameter
                                    </th>

                                    <th>
                                        Value
                                    </th>

                                    <th>
                                        Unit
                                    </th>

                                </tr>


                            </thead>



                            <tbody>



                                <tr>

                                    <td>
                                        Calculated Vapor Fraction
                                    </td>

                                    <td>
                                        {
                                            (vaporFraction * 100)
                                                .toFixed(2)
                                        }
                                    </td>

                                    <td>
                                        %
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Hydrocarbon Vapor Generation
                                    </td>

                                    <td>
                                        {
                                            Number(VaporGeneration || 0)
                                                .toFixed(3)
                                        }
                                    </td>

                                    <td>
                                        BPM
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Liquid Remaining Fraction
                                    </td>

                                    <td>
                                        {
                                            ((1 - vaporFraction) * 100)
                                                .toFixed(2)
                                        }
                                    </td>

                                    <td>
                                        %
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Overhead Vapor Flow
                                    </td>

                                    <td>
                                        {
                                            Number(FIC_16009 || 0)
                                                .toFixed(3)
                                        }
                                    </td>

                                    <td>
                                        BPM
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Bottoms Liquid Flow
                                    </td>

                                    <td>
                                        {
                                            Number(FIC_16013 || 0)
                                                .toFixed(3)
                                        }
                                    </td>

                                    <td>
                                        BPM
                                    </td>

                                </tr>



                            </tbody>


                        </table>



                        <br />



                        {/* ==========================================
        REFLUX AND STRIPPING EFFECT
========================================== */}



                        <h3 className="section-title">

                            REFLUX AND STRIPPING EFFECT

                        </h3>



                        <table className="receipt-table">


                            <thead>

                                <tr>

                                    <th>
                                        Parameter
                                    </th>

                                    <th>
                                        Value
                                    </th>

                                    <th>
                                        Unit
                                    </th>

                                </tr>

                            </thead>


                            <tbody>



                                <tr>

                                    <td>
                                        Reflux Flow
                                    </td>

                                    <td>
                                        {
                                            Number(FIC_16004 || 0)
                                                .toFixed(3)
                                        }
                                    </td>

                                    <td>
                                        BPM
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Reflux Ratio
                                    </td>

                                    <td>
                                        {
                                            Number(refluxRatio || 0)
                                                .toFixed(3)
                                        }
                                    </td>

                                    <td>
                                        -
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Water Injection Ratio
                                    </td>

                                    <td>
                                        {
                                            Number(waterRatio || 0)
                                                .toFixed(4)
                                        }
                                    </td>

                                    <td>
                                        -
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Steam Boost Factor
                                    </td>

                                    <td>
                                        {
                                            Number(steamBoost || 0)
                                                .toFixed(3)
                                        }
                                    </td>

                                    <td>
                                        -
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Reflux Cooling Effect
                                    </td>

                                    <td>
                                        {
                                            Number(RefluxCooling || 0)
                                                .toFixed(2)
                                        }
                                    </td>

                                    <td>
                                        °C equivalent
                                    </td>

                                </tr>



                            </tbody>


                        </table>



                        <br />



                        {/* ==========================================
        PERFORMANCE SUMMARY
========================================== */}



                        <h3 className="section-title">

                            PERFORMANCE SUMMARY

                        </h3>



                        <table className="receipt-table">


                            <tbody>



                                <tr>

                                    <td>
                                        Material Balance
                                    </td>

                                    <td>

                                        {

                                            TotalFeed > 0

                                                ?

                                                (
                                                    (
                                                        FIC_16009 +
                                                        FIC_16013
                                                    )
                                                    / TotalFeed
                                                    * 100
                                                ).toFixed(2)

                                                :

                                                100

                                        }

                                        %

                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Light End Recovery
                                    </td>

                                    <td>

                                        {
                                            (vaporFraction * 100)
                                                .toFixed(2)
                                        }
                                        %

                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Tower Separation Status
                                    </td>


                                    <td
                                        style={{
                                            color:
                                                vaporFraction > 0.05
                                                    ?
                                                    "green"
                                                    :
                                                    "orange",

                                            fontWeight: "bold"

                                        }}
                                    >

                                        {

                                            vaporFraction > 0.05

                                                ?

                                                "OPTIMUM FLASHING CONDITION"

                                                :

                                                "LOW VAPORIZATION"

                                        }

                                    </td>


                                </tr>



                            </tbody>


                        </table>




                        <br />



                        {/* ==========================================
        ENGINEERING NOTE
========================================== */}



                        <div

                            style={{

                                border: "1px solid #ccc",

                                padding: 15,

                                borderRadius: 8,

                                background: "#fafafa",

                                lineHeight: 1.7

                            }}

                        >


                            <strong>
                                ENGINEERING NOTE
                            </strong>


                            <p>

                                The Pre-Flash Tower operating condition is evaluated based on
                                feed thermal condition, reflux loading, stripping assistance and
                                calculated vapor-liquid equilibrium behavior.

                                The current simulation predicts the quantity of hydrocarbon vapor
                                removed before the Atmospheric Distillation Unit, reducing furnace
                                duty and improving downstream fractionation stability.

                            </p>


                        </div>


                    </div>

                )}


                {currentPage === 4 && (

                    <div>


                        {/* ==========================================
        PAGE HEADER
========================================== */}

                        <h1 className="receipt-title">

                            PRE-FLASH TOWER PROFILE ANALYSIS

                        </h1>


                        <h2 className="receipt-subtitle">

                            TEMPERATURE AND PRESSURE DISTRIBUTION

                        </h2>


                        <hr />



                        {/* ==========================================
        TOWER PROFILE TABLE
========================================== */}


                        <h3 className="section-title">

                            TOWER INTERNAL PROFILE

                        </h3>



                        <table className="receipt-table">


                            <thead>

                                <tr>

                                    <th>
                                        Section
                                    </th>

                                    <th>
                                        Temperature
                                    </th>

                                    <th>
                                        Pressure
                                    </th>

                                    <th>
                                        Condition
                                    </th>

                                </tr>

                            </thead>



                            <tbody>


                                <tr>


                                    <td>

                                        TOP SECTION

                                    </td>


                                    <td>

                                        {
                                            Number(tower.top.temperature || 0)
                                                .toFixed(2)
                                        }

                                        °C

                                    </td>


                                    <td>

                                        {
                                            Number(PT_16002 || 0)
                                                .toFixed(3)
                                        }

                                        MPa

                                    </td>


                                    <td>

                                        VAPOR RICH ZONE

                                    </td>


                                </tr>



                                <tr>


                                    <td>

                                        MIDDLE SECTION

                                    </td>


                                    <td>

                                        {
                                            Number(TT_16003 || 0)
                                                .toFixed(2)
                                        }

                                        °C

                                    </td>


                                    <td>

                                        {
                                            Number(PT_16003 || 0)
                                                .toFixed(3)
                                        }

                                        MPa

                                    </td>


                                    <td>

                                        FLASHING / EQUILIBRIUM ZONE

                                    </td>


                                </tr>




                                <tr>


                                    <td>

                                        BOTTOM SECTION

                                    </td>


                                    <td>

                                        {
                                            Number(TT_16004 || 0)
                                                .toFixed(2)
                                        }

                                        °C

                                    </td>


                                    <td>

                                        {
                                            Number(PT_16004 || 0)
                                                .toFixed(3)
                                        }

                                        MPa

                                    </td>


                                    <td>

                                        LIQUID RICH ZONE

                                    </td>


                                </tr>



                            </tbody>


                        </table>



                        <br />



                        {/* ==========================================
        TEMPERATURE GRADIENT
========================================== */}



                        <h3 className="section-title">

                            TEMPERATURE PROFILE ANALYSIS

                        </h3>



                        <table className="receipt-table">


                            <thead>

                                <tr>

                                    <th>
                                        Parameter
                                    </th>

                                    <th>
                                        Value
                                    </th>

                                    <th>
                                        Unit
                                    </th>

                                </tr>

                            </thead>


                            <tbody>


                                <tr>

                                    <td>
                                        Feed Temperature
                                    </td>

                                    <td>

                                        {
                                            Number(TT_16001 || 0)
                                                .toFixed(2)

                                        }

                                    </td>

                                    <td>
                                        °C
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Top Temperature Drop

                                    </td>

                                    <td>

                                        {

                                            (
                                                TT_16001 -
                                                tower.top.temperature
                                            )
                                                .toFixed(2)

                                        }

                                    </td>

                                    <td>
                                        °C
                                    </td>


                                </tr>



                                <tr>

                                    <td>
                                        Middle Temperature Drop

                                    </td>

                                    <td>

                                        {

                                            (
                                                TT_16001 -
                                                TT_16003
                                            )
                                                .toFixed(2)

                                        }

                                    </td>

                                    <td>
                                        °C
                                    </td>


                                </tr>



                                <tr>

                                    <td>
                                        Bottom Temperature Difference

                                    </td>

                                    <td>

                                        {

                                            (
                                                TT_16004 -
                                                TT_16001
                                            )
                                                .toFixed(2)

                                        }

                                    </td>

                                    <td>
                                        °C
                                    </td>


                                </tr>


                            </tbody>


                        </table>



                        <br />



                        {/* ==========================================
        PRESSURE PROFILE
========================================== */}



                        <h3 className="section-title">

                            PRESSURE PROFILE

                        </h3>



                        <table className="receipt-table">


                            <thead>

                                <tr>

                                    <th>
                                        Section
                                    </th>

                                    <th>
                                        Pressure
                                    </th>

                                    <th>
                                        Pressure Drop
                                    </th>

                                </tr>

                            </thead>



                            <tbody>


                                <tr>

                                    <td>
                                        Top Section
                                    </td>

                                    <td>

                                        {
                                            Number(PT_16002 || 0)
                                                .toFixed(3)

                                        }
                                        MPa

                                    </td>


                                    <td>

                                        {

                                            (
                                                PT_16003 -
                                                PT_16002
                                            )
                                                .toFixed(3)

                                        }

                                        MPa

                                    </td>


                                </tr>



                                <tr>

                                    <td>
                                        Middle Section
                                    </td>


                                    <td>

                                        {
                                            Number(PT_16003 || 0)
                                                .toFixed(3)

                                        }
                                        MPa

                                    </td>


                                    <td>

                                        {

                                            (
                                                PT_16004 -
                                                PT_16003
                                            )
                                                .toFixed(3)

                                        }

                                        MPa

                                    </td>


                                </tr>



                                <tr>

                                    <td>
                                        Bottom Section
                                    </td>


                                    <td>

                                        {
                                            Number(PT_16004 || 0)
                                                .toFixed(3)

                                        }
                                        MPa

                                    </td>


                                    <td>

                                        ---

                                    </td>


                                </tr>



                            </tbody>


                        </table>




                        <br />



                        {/* ==========================================
        ENGINEERING INTERPRETATION
========================================== */}



                        <h3 className="section-title">

                            ENGINEERING INTERPRETATION

                        </h3>



                        <div

                            style={{

                                border: "1px solid #ccc",

                                padding: "15px",

                                borderRadius: "8px",

                                background: "#fafafa",

                                lineHeight: "1.7"

                            }}

                        >



                            <p>


                                <strong>Top Section:</strong>

                                The upper section contains the lighter hydrocarbon vapors
                                generated from flashing of the crude feed. Lower temperature
                                promotes condensation of refluxed components.


                            </p>



                            <p>


                                <strong>Middle Section:</strong>

                                The middle section represents the vapor-liquid equilibrium zone
                                where partial condensation and stripping occur.


                            </p>



                            <p>


                                <strong>Bottom Section:</strong>

                                The bottom section contains the heavier crude fractions including
                                diesel range components, VGO and residue which remain liquid after
                                flashing.


                            </p>



                        </div>




                        <br />



                        {/* ==========================================
        OPERATING STATUS
========================================== */}



                        <h3 className="section-title">

                            TOWER OPERATING STATUS

                        </h3>



                        <table className="receipt-table">


                            <tbody>


                                <tr>

                                    <td>
                                        Temperature Gradient
                                    </td>

                                    <td

                                        style={{

                                            fontWeight: "bold",

                                            color:

                                                TT_16004 > TT_16003

                                                    ?

                                                    "green"

                                                    :

                                                    "orange"

                                        }}

                                    >

                                        {

                                            TT_16004 > TT_16003

                                                ?

                                                "NORMAL"

                                                :

                                                "CHECK PROFILE"

                                        }

                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Pressure Profile
                                    </td>


                                    <td

                                        style={{

                                            fontWeight: "bold",

                                            color:

                                                PT_16004 >= PT_16003

                                                    ?

                                                    "green"

                                                    :

                                                    "orange"

                                        }}

                                    >

                                        {

                                            PT_16004 >= PT_16003

                                                ?

                                                "STABLE"
                                                :
                                                "UNSTABLE"
                                        }
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                )}


                {currentPage === 5 && (

                    <div>


                        {/* ==========================================
        PAGE HEADER
========================================== */}


                        <h1 className="receipt-title">

                            PRE-FLASH OVERHEAD LABORATORY REPORT

                        </h1>


                        <h2 className="receipt-subtitle">

                            LIGHT HYDROCARBON VAPOR STREAM ANALYSIS

                        </h2>


                        <hr />



                        {/* ==========================================
        OVERHEAD STREAM CONDITION
========================================== */}



                        <h3 className="section-title">

                            OVERHEAD STREAM CONDITION

                        </h3>



                        <table className="receipt-table">


                            <thead>

                                <tr>

                                    <th>
                                        Parameter
                                    </th>

                                    <th>
                                        Value
                                    </th>

                                    <th>
                                        Unit
                                    </th>

                                </tr>

                            </thead>



                            <tbody>


                                <tr>

                                    <td>
                                        Stream Name
                                    </td>

                                    <td>
                                        Pre-Flash Tower Overhead Vapor
                                    </td>

                                    <td>
                                        -
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Flow Rate
                                    </td>

                                    <td>

                                        {
                                            Number(FIC_16009 || 0)
                                                .toFixed(3)

                                        }

                                    </td>

                                    <td>
                                        BPM
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Temperature
                                    </td>

                                    <td>

                                        {
                                            Number(tower.top.temperature || 0)
                                                .toFixed(2)

                                        }

                                    </td>

                                    <td>
                                        °C
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Pressure
                                    </td>

                                    <td>

                                        {
                                            Number(PT_16002 || 0)
                                                .toFixed(3)

                                        }

                                    </td>

                                    <td>
                                        MPa
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Phase Condition
                                    </td>

                                    <td>
                                        Vapor / Light Hydrocarbon Rich
                                    </td>

                                    <td>
                                        -
                                    </td>

                                </tr>



                            </tbody>


                        </table>



                        <br />



                        {/* ==========================================
        OVERHEAD COMPOSITION
========================================== */}



                        <h3 className="section-title">

                            OVERHEAD COMPONENT DISTRIBUTION

                        </h3>



                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>Component</th>

                                    <th>Flow Contribution</th>

                                    <th>Unit</th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr>

                                    <td>Light Naphtha</td>

                                    <td>
                                        {Number(
                                            overhead?.composition?.LightNaphtha || 0
                                        ).toFixed(3)}
                                    </td>

                                    <td>BPM</td>

                                </tr>

                                <tr>

                                    <td>Heavy Naphtha</td>

                                    <td>
                                        {Number(
                                            overhead?.composition?.HeavyNaphtha || 0
                                        ).toFixed(3)}
                                    </td>

                                    <td>BPM</td>

                                </tr>

                                <tr>

                                    <td>Kerosene</td>

                                    <td>
                                        {Number(
                                            overhead?.composition?.Kerosene || 0
                                        ).toFixed(3)}
                                    </td>

                                    <td>BPM</td>

                                </tr>

                                <tr>

                                    <td>Diesel</td>

                                    <td>
                                        {Number(
                                            overhead?.composition?.Diesel || 0
                                        ).toFixed(3)}
                                    </td>

                                    <td>BPM</td>

                                </tr>

                                <tr>

                                    <td>VGO</td>

                                    <td>
                                        {Number(
                                            overhead?.composition?.VGO || 0
                                        ).toFixed(3)}
                                    </td>

                                    <td>BPM</td>

                                </tr>

                                <tr>

                                    <td>Residue</td>

                                    <td>
                                        {Number(
                                            overhead?.composition?.Residue || 0
                                        ).toFixed(3)}
                                    </td>

                                    <td>BPM</td>

                                </tr>

                            </tbody>

                        </table>




                        <br />



                        {/* ==========================================
        RECOVERY ANALYSIS
========================================== */}



                        <h3 className="section-title">

                            LIGHT END RECOVERY PERFORMANCE

                        </h3>




                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>Component</th>

                                    <th>Original Yield</th>

                                    <th>Recovered Overhead</th>

                                    <th>Recovery %</th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr>

                                    <td>Light Naphtha</td>

                                    <td>
                                        {Number(bottoms.composition?.LightNaphtha + overhead.composition?.LightNaphtha || 0).toFixed(2)}
                                        wt%
                                    </td>

                                    <td>
                                        {Number(overhead.composition?.LightNaphtha || 0).toFixed(2)}
                                    </td>

                                    <td>
                                        {
                                            (
                                                (
                                                    Number(overhead.composition?.LightNaphtha || 0)
                                                    /
                                                    Math.max(
                                                        Number(
                                                            (bottoms.composition?.LightNaphtha || 0) +
                                                            (overhead.composition?.LightNaphtha || 0)
                                                        ),
                                                        0.000001
                                                    )
                                                ) * 100
                                            ).toFixed(2)
                                        }
                                        %
                                    </td>

                                </tr>

                                <tr>

                                    <td>Heavy Naphtha</td>

                                    <td>
                                        {Number(bottoms.composition?.HeavyNaphtha + overhead.composition?.HeavyNaphtha || 0).toFixed(2)}
                                        wt%
                                    </td>

                                    <td>
                                        {Number(overhead.composition?.HeavyNaphtha || 0).toFixed(2)}
                                    </td>

                                    <td>
                                        {
                                            (
                                                (
                                                    Number(overhead.composition?.HeavyNaphtha || 0)
                                                    /
                                                    Math.max(
                                                        Number(
                                                            (bottoms.composition?.HeavyNaphtha || 0) +
                                                            (overhead.composition?.HeavyNaphtha || 0)
                                                        ),
                                                        0.000001
                                                    )
                                                ) * 100
                                            ).toFixed(2)
                                        }
                                        %
                                    </td>

                                </tr>

                                <tr>

                                    <td>Kerosene</td>

                                    <td>
                                        {Number(bottoms.composition?.Kerosene + overhead.composition?.Kerosene || 0).toFixed(2)}
                                        wt%
                                    </td>

                                    <td>
                                        {Number(overhead.composition?.Kerosene || 0).toFixed(2)}
                                    </td>

                                    <td>
                                        {
                                            (
                                                (
                                                    Number(overhead.composition?.Kerosene || 0)
                                                    /
                                                    Math.max(
                                                        Number(
                                                            (bottoms.composition?.Kerosene || 0) +
                                                            (overhead.composition?.Kerosene || 0)
                                                        ),
                                                        0.000001
                                                    )
                                                ) * 100
                                            ).toFixed(2)
                                        }
                                        %
                                    </td>

                                </tr>

                                <tr>

                                    <td>Diesel</td>

                                    <td>
                                        {Number(bottoms.composition?.Diesel + overhead.composition?.Diesel || 0).toFixed(2)}
                                        wt%
                                    </td>

                                    <td>
                                        {Number(overhead.composition?.Diesel || 0).toFixed(2)}
                                    </td>

                                    <td>
                                        {
                                            (
                                                (
                                                    Number(overhead.composition?.Diesel || 0)
                                                    /
                                                    Math.max(
                                                        Number(
                                                            (bottoms.composition?.Diesel || 0) +
                                                            (overhead.composition?.Diesel || 0)
                                                        ),
                                                        0.000001
                                                    )
                                                ) * 100
                                            ).toFixed(2)
                                        }
                                        %
                                    </td>

                                </tr>

                                <tr>

                                    <td>VGO</td>

                                    <td>
                                        {Number(bottoms.composition?.VGO + overhead.composition?.VGO || 0).toFixed(2)}
                                        wt%
                                    </td>

                                    <td>
                                        {Number(overhead.composition?.VGO || 0).toFixed(2)}
                                    </td>

                                    <td>
                                        {
                                            (
                                                (
                                                    Number(overhead.composition?.VGO || 0)
                                                    /
                                                    Math.max(
                                                        Number(
                                                            (bottoms.composition?.VGO || 0) +
                                                            (overhead.composition?.VGO || 0)
                                                        ),
                                                        0.000001
                                                    )
                                                ) * 100
                                            ).toFixed(2)
                                        }
                                        %
                                    </td>

                                </tr>

                                <tr>

                                    <td>Residue</td>

                                    <td>
                                        {Number(bottoms.composition?.Residue + overhead.composition?.Residue || 0).toFixed(2)}
                                        wt%
                                    </td>

                                    <td>
                                        {Number(overhead.composition?.Residue || 0).toFixed(2)}
                                    </td>

                                    <td>
                                        {
                                            (
                                                (
                                                    Number(overhead.composition?.Residue || 0)
                                                    /
                                                    Math.max(
                                                        Number(
                                                            (bottoms.composition?.Residue || 0) +
                                                            (overhead.composition?.Residue || 0)
                                                        ),
                                                        0.000001
                                                    )
                                                ) * 100
                                            ).toFixed(2)
                                        }
                                        %
                                    </td>

                                </tr>

                            </tbody>

                        </table>




                        <br />



                        {/* ==========================================
        OVERHEAD QUALITY ASSESSMENT
========================================== */}



                        <h3 className="section-title">

                            OVERHEAD QUALITY ASSESSMENT

                        </h3>




                        <table className="receipt-table">


                            <tbody>



                                <tr>

                                    <td>
                                        Primary Product Recovered
                                    </td>

                                    <td>

                                        LIGHT NAPHTHA

                                    </td>

                                </tr>




                                <tr>

                                    <td>
                                        Hydrocarbon Recovery Mode
                                    </td>

                                    <td>

                                        {

                                            vaporFraction > 0.05

                                                ?

                                                "ACTIVE FLASHING"

                                                :

                                                "LOW FLASHING"

                                        }

                                    </td>

                                </tr>




                                <tr>

                                    <td>
                                        Heavy Component Carryover
                                    </td>


                                    <td>


                                        {

                                            (
                                                (
                                                    OverheadComposition.HeavyNaphtha || 0
                                                )

                                                >

                                                0

                                            )

                                                ?

                                                "DETECTED"

                                                :

                                                "NONE"

                                        }


                                    </td>


                                </tr>



                                <tr>

                                    <td>
                                        Overhead Product Condition
                                    </td>


                                    <td

                                        style={{

                                            fontWeight: "bold",

                                            color:

                                                vaporFraction > 0.05

                                                    ?

                                                    "green"

                                                    :

                                                    "orange"

                                        }}

                                    >


                                        {

                                            vaporFraction > 0.05

                                                ?

                                                "ACCEPTABLE"

                                                :

                                                "LOW VAPOR RECOVERY"

                                        }


                                    </td>


                                </tr>



                            </tbody>


                        </table>




                        <br />



                        <div

                            style={{

                                border: "1px solid #ccc",

                                padding: "15px",

                                borderRadius: "8px",

                                background: "#fafafa",

                                lineHeight: "1.6"

                            }}

                        >


                            <strong>
                                ENGINEERING COMMENT:
                            </strong>

                            <p>

                                The Pre-Flash Tower overhead stream represents the light hydrocarbon
                                fraction removed before atmospheric distillation. The separation is
                                dominated by light and heavy naphtha components with minor kerosene
                                carryover depending on operating temperature, pressure and reflux
                                conditions.

                            </p>
                        </div>
                    </div>
                )}

                {currentPage === 6 && (

                    <div>


                        {/* ==========================================
        PAGE HEADER
========================================== */}

                        <h1 className="receipt-title">

                            PRE-FLASH BOTTOMS LABORATORY REPORT

                        </h1>


                        <h2 className="receipt-subtitle">

                            HEAVY LIQUID STREAM ANALYSIS

                        </h2>


                        <hr />



                        {/* ==========================================
        BOTTOM STREAM CONDITION
========================================== */}


                        <h3 className="section-title">

                            BOTTOMS STREAM CONDITION

                        </h3>



                        <table className="receipt-table">


                            <thead>

                                <tr>

                                    <th>
                                        Parameter
                                    </th>

                                    <th>
                                        Value
                                    </th>

                                    <th>
                                        Unit
                                    </th>

                                </tr>

                            </thead>



                            <tbody>


                                <tr>

                                    <td>
                                        Stream Name
                                    </td>

                                    <td>
                                        Pre-Flash Tower Bottoms
                                    </td>

                                    <td>
                                        -
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Flow Rate
                                    </td>

                                    <td>

                                        {
                                            Number(FIC_16013 || 0)
                                                .toFixed(3)

                                        }

                                    </td>

                                    <td>
                                        BPM
                                    </td>

                                </tr>




                                <tr>

                                    <td>
                                        Temperature
                                    </td>

                                    <td>

                                        {
                                            Number(TT_16004 || 0)
                                                .toFixed(2)

                                        }

                                    </td>

                                    <td>
                                        °C
                                    </td>

                                </tr>




                                <tr>

                                    <td>
                                        Pressure
                                    </td>

                                    <td>

                                        {
                                            Number(PT_16004 || 0)
                                                .toFixed(3)

                                        }

                                    </td>

                                    <td>
                                        MPa
                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Phase Condition
                                    </td>

                                    <td>
                                        Heavy Liquid Hydrocarbon
                                    </td>

                                    <td>
                                        -
                                    </td>

                                </tr>



                            </tbody>


                        </table>



                        <br />



                        {/* ==========================================
        BOTTOMS COMPOSITION
========================================== */}



                        <h3 className="section-title">

                            BOTTOMS COMPONENT DISTRIBUTION

                        </h3>



                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>
                                        Component
                                    </th>

                                    <th>
                                        Retained Flow
                                    </th>

                                    <th>
                                        Unit
                                    </th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr>

                                    <td>
                                        Light Naphtha
                                    </td>

                                    <td>
                                        {Number(bottoms.flowComposition?.LightNaphtha || 0).toFixed(3)}
                                    </td>

                                    <td>
                                        BPM
                                    </td>

                                </tr>

                                <tr>

                                    <td>
                                        Heavy Naphtha
                                    </td>

                                    <td>
                                        {Number(bottoms.flowComposition?.HeavyNaphtha || 0).toFixed(3)}
                                    </td>

                                    <td>
                                        BPM
                                    </td>

                                </tr>

                                <tr>

                                    <td>
                                        Kerosene
                                    </td>

                                    <td>
                                        {Number(bottoms.flowComposition?.Kerosene || 0).toFixed(3)}
                                    </td>

                                    <td>
                                        BPM
                                    </td>

                                </tr>

                                <tr>

                                    <td>
                                        Diesel
                                    </td>

                                    <td>
                                        {Number(bottoms.flowComposition?.Diesel || 0).toFixed(3)}
                                    </td>

                                    <td>
                                        BPM
                                    </td>

                                </tr>

                                <tr>

                                    <td>
                                        VGO
                                    </td>

                                    <td>
                                        {Number(bottoms.flowComposition?.VGO || 0).toFixed(3)}
                                    </td>

                                    <td>
                                        BPM
                                    </td>

                                </tr>

                                <tr>

                                    <td>
                                        Residue
                                    </td>

                                    <td>
                                        {Number(bottoms.flowComposition?.Residue || 0).toFixed(3)}
                                    </td>

                                    <td>
                                        BPM
                                    </td>

                                </tr>

                            </tbody>

                        </table>




                        <br />



                        {/* ==========================================
        HEAVY FRACTION RECOVERY
========================================== */}



                        <h3 className="section-title">

                            HEAVY FRACTION RETENTION PERFORMANCE

                        </h3>




                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>
                                        Component
                                    </th>

                                    <th>
                                        Feed Yield
                                    </th>

                                    <th>
                                        Bottoms Recovery
                                    </th>

                                    <th>
                                        Recovery %
                                    </th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr>

                                    <td>
                                        Diesel
                                    </td>

                                    <td>
                                        {Number(TotalDiesel || 0).toFixed(2)} wt%
                                    </td>

                                    <td>
                                        {Number(bottoms.composition?.Diesel || 0).toFixed(2)}
                                    </td>

                                    <td>
                                        {TotalDiesel > 0
                                            ? (
                                                (bottoms.composition?.Diesel || 0) /
                                                TotalDiesel *
                                                100
                                            ).toFixed(2)
                                            : "0.00"}
                                        %
                                    </td>

                                </tr>

                                <tr>

                                    <td>
                                        VGO
                                    </td>

                                    <td>
                                        {Number(TotalVGO || 0).toFixed(2)} wt%
                                    </td>

                                    <td>
                                        {Number(bottoms.composition?.VGO || 0).toFixed(2)}
                                    </td>

                                    <td>
                                        {TotalVGO > 0
                                            ? (
                                                (bottoms.composition?.VGO || 0) /
                                                TotalVGO *
                                                100
                                            ).toFixed(2)
                                            : "0.00"}
                                        %
                                    </td>

                                </tr>

                                <tr>

                                    <td>
                                        Residue
                                    </td>

                                    <td>
                                        {Number(TotalResidue || 0).toFixed(2)} wt%
                                    </td>

                                    <td>
                                        {Number(bottoms.composition?.Residue || 0).toFixed(2)}
                                    </td>

                                    <td>
                                        {TotalResidue > 0
                                            ? (
                                                (bottoms.composition?.Residue || 0) /
                                                TotalResidue *
                                                100
                                            ).toFixed(2)
                                            : "0.00"}
                                        %
                                    </td>

                                </tr>

                            </tbody>

                        </table>




                        <br />



                        {/* ==========================================
        FURNACE FEED SUITABILITY
========================================== */}



                        <h3 className="section-title">

                            FURNACE FEED SUITABILITY ASSESSMENT

                        </h3>




                        <table className="receipt-table">


                            <tbody>



                                <tr>

                                    <td>
                                        Heavy Hydrocarbon Retention
                                    </td>


                                    <td>


                                        {

                                            (
                                                (BottomsComposition?.VGO || 0)
                                                +
                                                (BottomsComposition?.Residue || 0)

                                            )

                                                >

                                                50

                                                ?

                                                "HIGH"

                                                :

                                                "MODERATE"

                                        }


                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        Light Component Carryover
                                    </td>


                                    <td>


                                        {

                                            (
                                                (BottomsComposition?.LightNaphtha || 0)

                                            )

                                                >

                                                0

                                                ?

                                                "TRACE LIGHT ENDS PRESENT"

                                                :

                                                "MINIMAL"

                                        }



                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        Furnace Feed Condition
                                    </td>


                                    <td

                                        style={{

                                            fontWeight: "bold",

                                            color:

                                                FIC_16013 > 0

                                                    ?

                                                    "green"

                                                    :

                                                    "red"

                                        }}

                                    >


                                        {

                                            FIC_16013 > 0

                                                ?

                                                "AVAILABLE"

                                                :

                                                "NO FLOW"

                                        }


                                    </td>


                                </tr>




                                <tr>

                                    <td>
                                        Recommended Destination
                                    </td>


                                    <td>

                                        ATMOSPHERIC DISTILLATION FURNACE

                                    </td>


                                </tr>



                            </tbody>


                        </table>





                        <br />



                        <div

                            style={{

                                border: "1px solid #ccc",

                                padding: "15px",

                                borderRadius: "8px",

                                background: "#fafafa",

                                lineHeight: "1.6"

                            }}

                        >


                            <strong>
                                ENGINEERING COMMENT:
                            </strong>


                            <p>

                                The Pre-Flash Tower bottoms stream contains the majority of the
                                high boiling hydrocarbons including diesel, vacuum gas oil and residue
                                fractions. This stream is suitable as furnace feed for the atmospheric
                                distillation section after removal of light components in the Pre-Flash
                                Tower.

                            </p>
                        </div>
                    </div>
                )}



                {currentPage === 7 && (

                    <div>


                        {/* ==========================================
        PAGE HEADER
========================================== */}

                        <h1 className="receipt-title">

                            PRE-FLASH TOWER MATERIAL BALANCE

                        </h1>


                        <h2 className="receipt-subtitle">

                            SEPARATION PERFORMANCE ANALYSIS

                        </h2>


                        <hr />



                        {/* ==========================================
        OVERALL MATERIAL BALANCE
========================================== */}



                        <h3 className="section-title">

                            OVERALL MATERIAL BALANCE

                        </h3>



                        <table className="receipt-table">


                            <thead>

                                <tr>

                                    <th>
                                        Stream
                                    </th>

                                    <th>
                                        Flow
                                    </th>

                                    <th>
                                        Unit
                                    </th>

                                    <th>
                                        Percentage
                                    </th>

                                </tr>

                            </thead>



                            <tbody>



                                <tr>

                                    <td>
                                        Total Feed
                                    </td>


                                    <td>

                                        {

                                            Number(TotalFeed || 0)
                                                .toFixed(3)

                                        }

                                    </td>


                                    <td>
                                        BPM
                                    </td>


                                    <td>
                                        100 %

                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        Overhead Product

                                    </td>


                                    <td>

                                        {

                                            Number(FIC_16009 || 0)
                                                .toFixed(3)

                                        }

                                    </td>


                                    <td>
                                        BPM

                                    </td>


                                    <td>


                                        {

                                            TotalFeed > 0

                                                ?

                                                (
                                                    FIC_16009 /
                                                    TotalFeed *
                                                    100

                                                ).toFixed(2)

                                                :

                                                0

                                        }

                                        %


                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        Bottom Product

                                    </td>


                                    <td>

                                        {

                                            Number(FIC_16013 || 0)
                                                .toFixed(3)

                                        }

                                    </td>


                                    <td>
                                        BPM

                                    </td>


                                    <td>


                                        {

                                            TotalFeed > 0

                                                ?

                                                (
                                                    FIC_16013 /
                                                    TotalFeed *
                                                    100

                                                ).toFixed(2)

                                                :

                                                0

                                        }

                                        %


                                    </td>


                                </tr>




                            </tbody>


                        </table>





                        <br />



                        {/* ==========================================
        BALANCE CLOSURE
========================================== */}



                        <h3 className="section-title">

                            MATERIAL BALANCE CLOSURE

                        </h3>




                        <table className="receipt-table">


                            <tbody>



                                <tr>

                                    <td>
                                        Feed Input

                                    </td>


                                    <td>

                                        {

                                            Number(TotalFeed || 0)
                                                .toFixed(3)

                                        }

                                        BPM

                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        Products Out

                                    </td>


                                    <td>

                                        {

                                            Number(
                                                (
                                                    FIC_16009 +
                                                    FIC_16013
                                                )

                                                || 0)
                                                .toFixed(3)

                                        }

                                        BPM

                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        Balance Error

                                    </td>


                                    <td>


                                        {

                                            TotalFeed > 0

                                                ?

                                                (
                                                    (
                                                        (
                                                            FIC_16009 +
                                                            FIC_16013
                                                        )

                                                        -

                                                        TotalFeed
                                                    )
                                                    /
                                                    TotalFeed
                                                    *
                                                    100

                                                ).toFixed(3)

                                                :

                                                0

                                        }


                                        %

                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        Balance Status

                                    </td>


                                    <td

                                        style={{

                                            fontWeight: "bold"

                                        }}

                                    >


                                        {

                                            Math.abs(

                                                (
                                                    (
                                                        FIC_16009 +
                                                        FIC_16013
                                                    )

                                                    -

                                                    TotalFeed
                                                )

                                                /
                                                TotalFeed
                                                *

                                                100

                                            )

                                                < 2

                                                ?

                                                "ACCEPTABLE"

                                                :

                                                "CHECK BALANCE"

                                        }


                                    </td>


                                </tr>




                            </tbody>


                        </table>





                        <br />



                        {/* ==========================================
        VAPORIZATION PERFORMANCE
========================================== */}



                        <h3 className="section-title">

                            VAPORIZATION PERFORMANCE

                        </h3>




                        <table className="receipt-table">


                            <thead>

                                <tr>

                                    <th>
                                        Parameter
                                    </th>

                                    <th>
                                        Value
                                    </th>

                                    <th>
                                        Unit
                                    </th>

                                </tr>


                            </thead>




                            <tbody>




                                <tr>

                                    <td>
                                        Vapor Fraction

                                    </td>


                                    <td>

                                        {

                                            Number(
                                                vaporFraction * 100
                                            )

                                                .toFixed(2)

                                        }

                                    </td>


                                    <td>
                                        %

                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        Hydrocarbon Vapor Generated

                                    </td>


                                    <td>

                                        {

                                            Number(
                                                VaporGeneration || 0
                                            )

                                                .toFixed(3)

                                        }

                                    </td>


                                    <td>
                                        BPM

                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        Liquid Remaining

                                    </td>


                                    <td>

                                        {

                                            Number(

                                                (
                                                    1 - vaporFraction
                                                )
                                                *
                                                100

                                            )

                                                .toFixed(2)

                                        }

                                    </td>


                                    <td>
                                        %

                                    </td>


                                </tr>




                            </tbody>


                        </table>





                        <br />



                        {/* ==========================================
        COMPONENT SEPARATION EFFICIENCY
========================================== */}



                        <h3 className="section-title">

                            LIGHT END REMOVAL EFFICIENCY

                        </h3>




                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>
                                        Component
                                    </th>

                                    <th>
                                        Feed Yield
                                    </th>

                                    <th>
                                        Overhead Recovery
                                    </th>

                                    <th>
                                        Removal %
                                    </th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr>

                                    <td>
                                        Light Naphtha
                                    </td>

                                    <td>
                                        {Number(TotalLightNaphtha || 0).toFixed(2)} wt%
                                    </td>

                                    <td>
                                        {Number(overhead.composition?.LightNaphtha || 0).toFixed(3)}
                                    </td>

                                    <td>
                                        {TotalLightNaphtha > 0
                                            ? (
                                                (overhead.composition?.LightNaphtha || 0) /
                                                TotalLightNaphtha *
                                                100
                                            ).toFixed(2)
                                            : "0.00"}
                                        %
                                    </td>

                                </tr>

                                <tr>

                                    <td>
                                        Heavy Naphtha
                                    </td>

                                    <td>
                                        {Number(TotalHeavyNaphtha || 0).toFixed(2)} wt%
                                    </td>

                                    <td>
                                        {Number(overhead.composition?.HeavyNaphtha || 0).toFixed(3)}
                                    </td>

                                    <td>
                                        {TotalHeavyNaphtha > 0
                                            ? (
                                                (overhead.composition?.HeavyNaphtha || 0) /
                                                TotalHeavyNaphtha *
                                                100
                                            ).toFixed(2)
                                            : "0.00"}
                                        %
                                    </td>

                                </tr>

                                <tr>

                                    <td>
                                        Kerosene
                                    </td>

                                    <td>
                                        {Number(TotalKerosene || 0).toFixed(2)} wt%
                                    </td>

                                    <td>
                                        {Number(overhead.composition?.Kerosene || 0).toFixed(3)}
                                    </td>

                                    <td>
                                        {TotalKerosene > 0
                                            ? (
                                                (overhead.composition?.Kerosene || 0) /
                                                TotalKerosene *
                                                100
                                            ).toFixed(2)
                                            : "0.00"}
                                        %
                                    </td>

                                </tr>

                            </tbody>

                        </table>






                        <br />



                        {/* ==========================================
        PERFORMANCE RATING
========================================== */}



                        <h3 className="section-title">

                            PRE-FLASH TOWER PERFORMANCE RATING

                        </h3>



                        <table className="receipt-table">


                            <tbody>



                                <tr>

                                    <td>
                                        Vaporization Severity

                                    </td>


                                    <td>


                                        {

                                            vaporFraction >= 0.10

                                                ?

                                                "HIGH"

                                                :

                                                "MODERATE"

                                        }


                                    </td>


                                </tr>




                                <tr>

                                    <td>
                                        Light Ends Recovery

                                    </td>


                                    <td>


                                        {

                                            OverheadComposition?.LightNaphtha > 0

                                                ?

                                                "EFFECTIVE"

                                                :

                                                "LOW"

                                        }


                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        Overall Separation Quality

                                    </td>


                                    <td

                                        style={{

                                            fontWeight: "bold"

                                        }}

                                    >


                                        {

                                            (
                                                Math.abs(

                                                    (
                                                        (
                                                            FIC_16009 +
                                                            FIC_16013
                                                        )

                                                        -
                                                        TotalFeed

                                                    )
                                                    /
                                                    TotalFeed

                                                    *

                                                    100

                                                )

                                                < 2

                                                &&

                                                vaporFraction > 0

                                            )

                                                ?

                                                "GOOD"

                                                :

                                                "REVIEW REQUIRED"

                                        }


                                    </td>


                                </tr>




                            </tbody>


                        </table>





                        <br />



                        <div

                            style={{

                                padding: "15px",

                                border: "1px solid #bbb",

                                borderRadius: "8px",

                                background: "#fafafa",

                                lineHeight: "1.6"

                            }}

                        >


                            <strong>
                                ENGINEERING COMMENT:
                            </strong>


                            <p>

                                The Pre-Flash Tower is operating within expected separation limits.
                                The material balance confirms reconciliation between feed, overhead
                                and bottoms streams. Light hydrocarbon removal is primarily controlled
                                by feed temperature, reflux rate and stripping water contribution.

                            </p>
                        </div>
                    </div>
                )}

                {currentPage === 8 && (

                    <div>


                        {/* ==========================================
        PAGE HEADER
========================================== */}

                        <h1 className="receipt-title">

                            PRE-FLASH TOWER COMPONENT MASS BALANCE

                        </h1>


                        <h2 className="receipt-subtitle">

                            CRUDE FRACTION DISTRIBUTION ANALYSIS

                        </h2>


                        <hr />





                        <h3 className="section-title">

                            COMPONENT DISTRIBUTION SUMMARY

                        </h3>




                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>
                                        Component
                                    </th>

                                    <th>
                                        Feed Yield
                                    </th>

                                    <th>
                                        Overhead
                                    </th>

                                    <th>
                                        Bottoms
                                    </th>

                                    <th>
                                        Recovery
                                    </th>

                                </tr>

                            </thead>

                            <tbody>

                                {/* LIGHT NAPHTHA */}

                                <tr>

                                    <td>
                                        Light Naphtha
                                    </td>

                                    <td>
                                        {Number(TotalLightNaphtha || 0).toFixed(2)} wt%
                                    </td>

                                    <td>
                                        {Number(overhead.composition?.LightNaphtha || 0).toFixed(3)}
                                    </td>

                                    <td>
                                        {Number(bottoms.composition?.LightNaphtha || 0).toFixed(3)}
                                    </td>

                                    <td>
                                        {TotalLightNaphtha > 0
                                            ? (
                                                (overhead.composition?.LightNaphtha || 0) /
                                                TotalLightNaphtha *
                                                100
                                            ).toFixed(2)
                                            : "0.00"}
                                        %
                                    </td>

                                </tr>

                                {/* HEAVY NAPHTHA */}

                                <tr>

                                    <td>
                                        Heavy Naphtha
                                    </td>

                                    <td>
                                        {Number(TotalHeavyNaphtha || 0).toFixed(2)} wt%
                                    </td>

                                    <td>
                                        {Number(overhead.composition?.HeavyNaphtha || 0).toFixed(3)}
                                    </td>

                                    <td>
                                        {Number(bottoms.composition?.HeavyNaphtha || 0).toFixed(3)}
                                    </td>

                                    <td>
                                        {TotalHeavyNaphtha > 0
                                            ? (
                                                (overhead.composition?.HeavyNaphtha || 0) /
                                                TotalHeavyNaphtha *
                                                100
                                            ).toFixed(2)
                                            : "0.00"}
                                        %
                                    </td>

                                </tr>

                                {/* KEROSENE */}

                                <tr>

                                    <td>
                                        Kerosene
                                    </td>

                                    <td>
                                        {Number(TotalKerosene || 0).toFixed(2)} wt%
                                    </td>

                                    <td>
                                        {Number(overhead.composition?.Kerosene || 0).toFixed(3)}
                                    </td>

                                    <td>
                                        {Number(bottoms.composition?.Kerosene || 0).toFixed(3)}
                                    </td>

                                    <td>
                                        {TotalKerosene > 0
                                            ? (
                                                (overhead.composition?.Kerosene || 0) /
                                                TotalKerosene *
                                                100
                                            ).toFixed(2)
                                            : "0.00"}
                                        %
                                    </td>

                                </tr>

                                {/* DIESEL */}

                                <tr>

                                    <td>
                                        Diesel
                                    </td>

                                    <td>
                                        {Number(TotalDiesel || 0).toFixed(2)} wt%
                                    </td>

                                    <td>
                                        {Number(overhead.composition?.Diesel || 0).toFixed(3)}
                                    </td>

                                    <td>
                                        {Number(bottoms.composition?.Diesel || 0).toFixed(3)}
                                    </td>

                                    <td>
                                        {TotalDiesel > 0
                                            ? (
                                                (overhead.composition?.Diesel || 0) /
                                                TotalDiesel *
                                                100
                                            ).toFixed(2)
                                            : "0.00"}
                                        %
                                    </td>

                                </tr>

                                {/* VGO */}

                                <tr>

                                    <td>
                                        Vacuum Gas Oil (VGO)
                                    </td>

                                    <td>
                                        {Number(TotalVGO || 0).toFixed(2)} wt%
                                    </td>

                                    <td>
                                        {Number(overhead.composition?.VGO || 0).toFixed(3)}
                                    </td>

                                    <td>
                                        {Number(bottoms.composition?.VGO || 0).toFixed(3)}
                                    </td>

                                    <td>
                                        {TotalVGO > 0
                                            ? (
                                                (overhead.composition?.VGO || 0) /
                                                TotalVGO *
                                                100
                                            ).toFixed(2)
                                            : "0.00"}
                                        %
                                    </td>

                                </tr>

                                {/* RESIDUE */}

                                <tr>

                                    <td>
                                        Atmospheric Residue
                                    </td>

                                    <td>
                                        {Number(TotalResidue || 0).toFixed(2)} wt%
                                    </td>

                                    <td>
                                        {Number(overhead.composition?.Residue || 0).toFixed(3)}
                                    </td>

                                    <td>
                                        {Number(bottoms.composition?.Residue || 0).toFixed(3)}
                                    </td>

                                    <td>
                                        {TotalResidue > 0
                                            ? (
                                                (overhead.composition?.Residue || 0) /
                                                TotalResidue *
                                                100
                                            ).toFixed(2)
                                            : "0.00"}
                                        %
                                    </td>

                                </tr>

                            </tbody>

                        </table>





                        <br />





                        {/* ==========================================
        STREAM BALANCE
========================================== */}



                        <h3 className="section-title">

                            STREAM FRACTION DISTRIBUTION

                        </h3>




                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>
                                        Stream
                                    </th>

                                    <th>
                                        Light Ends
                                    </th>

                                    <th>
                                        Middle Distillates
                                    </th>

                                    <th>
                                        Heavy Components
                                    </th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr>

                                    <td>
                                        Overhead Vapor
                                    </td>

                                    <td>

                                        {
                                            Number(
                                                (overhead.composition?.LightNaphtha || 0) +
                                                (overhead.composition?.HeavyNaphtha || 0)
                                            ).toFixed(3)
                                        }

                                    </td>

                                    <td>

                                        {
                                            Number(
                                                overhead.composition?.Kerosene || 0
                                            ).toFixed(3)
                                        }

                                    </td>

                                    <td>

                                        {
                                            Number(
                                                (overhead.composition?.VGO || 0) +
                                                (overhead.composition?.Residue || 0)
                                            ).toFixed(3)
                                        }

                                    </td>

                                </tr>

                                <tr>

                                    <td>
                                        Tower Bottoms
                                    </td>

                                    <td>

                                        {
                                            Number(
                                                (bottoms.composition?.LightNaphtha || 0) +
                                                (bottoms.composition?.HeavyNaphtha || 0)
                                            ).toFixed(3)
                                        }

                                    </td>

                                    <td>

                                        {
                                            Number(
                                                bottoms.composition?.Kerosene || 0
                                            ).toFixed(3)
                                        }

                                    </td>

                                    <td>

                                        {
                                            Number(
                                                (bottoms.composition?.VGO || 0) +
                                                (bottoms.composition?.Residue || 0)
                                            ).toFixed(3)
                                        }

                                    </td>

                                </tr>

                            </tbody>

                        </table>







                        <br />




                        {/* ==========================================
        ENGINEERING OBSERVATION
========================================== */}



                        <h3 className="section-title">

                            ENGINEERING OBSERVATION

                        </h3>



                        <div

                            style={{

                                padding: "15px",

                                border: "1px solid #bbb",

                                borderRadius: "8px",

                                background: "#fafafa",

                                lineHeight: "1.6"

                            }}

                        >


                            <strong>
                                PROCESS INTERPRETATION:
                            </strong>


                            <p>


                                The Pre-Flash Tower preferentially removes light hydrocarbons,
                                mainly Light Naphtha and a portion of Heavy Naphtha.
                                Heavy boiling fractions such as Diesel, VGO and Atmospheric
                                Residue remain predominantly in the bottoms stream.


                            </p>


                            <p>


                                The separation efficiency is influenced by feed temperature,
                                tower pressure, reflux cooling and stripping water addition.

                            </p>
                        </div>
                    </div>
                )}

                {currentPage === 9 && (

                    <div>


                        {/* ==========================================
        PAGE HEADER
========================================== */}

                        <h1 className="receipt-title">

                            PRE-FLASH TOWER PROCESS DIAGNOSTICS

                        </h1>


                        <h2 className="receipt-subtitle">

                            OPERATING HEALTH & PERFORMANCE ASSESSMENT

                        </h2>


                        <hr />





                        {/* ==========================================
        OPERATING SUMMARY
========================================== */}


                        <h3 className="section-title">

                            OPERATING CONDITION SUMMARY

                        </h3>



                        <table className="receipt-table">


                            <thead>

                                <tr>

                                    <th>
                                        Parameter
                                    </th>

                                    <th>
                                        Value
                                    </th>

                                    <th>
                                        Status
                                    </th>

                                </tr>


                            </thead>



                            <tbody>



                                <tr>

                                    <td>
                                        Feed Temperature
                                    </td>


                                    <td>

                                        {
                                            Number(
                                                TT_16001 || 0
                                            )

                                                .toFixed(2)

                                        }
                                        °C

                                    </td>


                                    <td>

                                        {

                                            TT_16001 > IBP

                                                ?

                                                "SUFFICIENT FLASHING"

                                                :

                                                "LOW VAPORIZATION"

                                        }

                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        Tower Feed Pressure
                                    </td>


                                    <td>

                                        {

                                            Number(
                                                PT_16001 || 0
                                            )

                                                .toFixed(3)

                                        }

                                        MPa

                                    </td>


                                    <td>

                                        NORMAL

                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        Reflux Ratio
                                    </td>


                                    <td>

                                        {

                                            Number(
                                                refluxRatio || 0
                                            )

                                                .toFixed(3)

                                        }

                                    </td>


                                    <td>

                                        {

                                            refluxRatio > 0.05

                                                ?

                                                "HIGH CONDENSATION EFFECT"

                                                :

                                                "NORMAL"

                                        }

                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        Water / Steam Ratio
                                    </td>


                                    <td>

                                        {

                                            Number(
                                                waterRatio || 0
                                            )

                                                .toFixed(3)

                                        }

                                    </td>


                                    <td>

                                        {

                                            waterRatio > 0

                                                ?

                                                "STRIPPING ACTIVE"

                                                :

                                                "NO STRIPPING"

                                        }

                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        Steam Boost Factor
                                    </td>


                                    <td>

                                        {

                                            Number(
                                                steamBoost || 0
                                            )

                                                .toFixed(3)

                                        }

                                    </td>


                                    <td>

                                        ACTIVE

                                    </td>


                                </tr>



                            </tbody>


                        </table>








                        <br />





                        {/* ==========================================
        FLASHING PERFORMANCE
========================================== */}



                        <h3 className="section-title">

                            FLASHING PERFORMANCE ANALYSIS

                        </h3>




                        <table className="receipt-table">


                            <thead>

                                <tr>

                                    <th>
                                        Parameter
                                    </th>

                                    <th>
                                        Result
                                    </th>

                                    <th>
                                        Assessment
                                    </th>

                                </tr>


                            </thead>




                            <tbody>



                                <tr>

                                    <td>
                                        Vapor Fraction
                                    </td>


                                    <td>

                                        {

                                            (
                                                vaporFraction *
                                                100

                                            ).toFixed(2)

                                        }

                                        %

                                    </td>


                                    <td>

                                        {

                                            vaporFraction >= 0.15

                                                ?

                                                "HIGH FLASHING"

                                                :

                                                vaporFraction >= 0.05

                                                    ?

                                                    "MODERATE FLASHING"

                                                    :

                                                    "LOW FLASHING"

                                        }

                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        Overhead Vapor Flow
                                    </td>


                                    <td>

                                        {

                                            Number(
                                                FIC_16009 || 0
                                            )

                                                .toFixed(3)

                                        }

                                        BPM

                                    </td>


                                    <td>

                                        LIGHT END RECOVERY

                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        Bottom Product Flow
                                    </td>


                                    <td>

                                        {

                                            Number(
                                                FIC_16013 || 0
                                            )

                                                .toFixed(3)

                                        }

                                        BPM

                                    </td>


                                    <td>

                                        LIQUID RECOVERY

                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        Liquid Recovery

                                    </td>


                                    <td>

                                        {

                                            (
                                                (1 - vaporFraction)
                                                *
                                                100

                                            ).toFixed(2)

                                        }

                                        %

                                    </td>


                                    <td>

                                        STABLE

                                    </td>


                                </tr>



                            </tbody>


                        </table>








                        <br />





                        {/* ==========================================
        TEMPERATURE PROFILE
========================================== */}



                        <h3 className="section-title">

                            TOWER TEMPERATURE PROFILE

                        </h3>




                        <table className="receipt-table">


                            <thead>


                                <tr>

                                    <th>
                                        Location
                                    </th>

                                    <th>
                                        Temperature
                                    </th>

                                    <th>
                                        Profile Condition
                                    </th>


                                </tr>


                            </thead>




                            <tbody>



                                <tr>

                                    <td>
                                        Top Section TT-16002
                                    </td>


                                    <td>

                                        {

                                            Number(
                                                tower.top.temperature || 0
                                            )

                                                .toFixed(2)

                                        }

                                        °C

                                    </td>


                                    <td>

                                        {

                                            tower.top.temperature < TT_16003

                                                ?

                                                "VALID PROFILE"

                                                :

                                                "CHECK PROFILE"

                                        }

                                    </td>


                                </tr>






                                <tr>

                                    <td>
                                        Middle Section TT-16003
                                    </td>


                                    <td>

                                        {

                                            Number(
                                                TT_16003 || 0
                                            )

                                                .toFixed(2)

                                        }

                                        °C

                                    </td>


                                    <td>

                                        INTERMEDIATE FRACTION ZONE

                                    </td>


                                </tr>







                                <tr>

                                    <td>
                                        Bottom Section TT-16004
                                    </td>


                                    <td>

                                        {

                                            Number(
                                                TT_16004 || 0
                                            )

                                                .toFixed(2)

                                        }

                                        °C

                                    </td>


                                    <td>

                                        HEAVY HYDROCARBON RETENTION

                                    </td>


                                </tr>




                            </tbody>


                        </table>







                        <br />







                        {/* ==========================================
        MATERIAL BALANCE
========================================== */}



                        <h3 className="section-title">

                            MATERIAL BALANCE VALIDATION

                        </h3>




                        <table className="receipt-table">


                            <tbody>



                                <tr>

                                    <td>
                                        Total Feed
                                    </td>


                                    <td>

                                        {

                                            Number(
                                                TotalFeed || 0
                                            )

                                                .toFixed(3)

                                        }

                                        BPM

                                    </td>


                                </tr>




                                <tr>

                                    <td>
                                        Total Products

                                    </td>


                                    <td>

                                        {

                                            Number(

                                                (
                                                    FIC_16009 +
                                                    FIC_16013

                                                )

                                                || 0

                                            )

                                                .toFixed(3)

                                        }

                                        BPM

                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        Balance Closure

                                    </td>


                                    <td>


                                        {

                                            TotalFeed > 0

                                                ?

                                                (

                                                    (
                                                        FIC_16009 +
                                                        FIC_16013

                                                    )

                                                    /

                                                    TotalFeed

                                                    *

                                                    100

                                                )

                                                    .toFixed(2)

                                                :

                                                100

                                        }


                                        %

                                    </td>


                                </tr>




                            </tbody>


                        </table>







                        <br />






                        {/* ==========================================
        ENGINEERING ASSESSMENT
========================================== */}



                        <h3 className="section-title">

                            ENGINEERING ASSESSMENT

                        </h3>




                        <div

                            style={{

                                padding: "15px",

                                border: "1px solid #bbb",

                                borderRadius: "8px",

                                background: "#fafafa",

                                lineHeight: "1.6"

                            }}

                        >


                            <strong>
                                PROCESS ENGINEER COMMENTS:
                            </strong>



                            <p>

                                The Pre-Flash Tower operating condition indicates that
                                the crude feed is undergoing controlled partial vaporization.
                                The separation efficiency depends on maintaining adequate
                                feed temperature, stable tower pressure and appropriate reflux
                                operation.

                            </p>



                            <p>

                                The calculated vapor fraction represents the amount of crude
                                converted into overhead vapor while maintaining maximum
                                recovery of heavier hydrocarbon components in the bottoms.

                            </p>



                            <p>

                                Current operation should be monitored for excessive vaporization,
                                high reflux requirement, and unstable temperature profile.

                            </p>
                        </div>
                    </div>
                )}




                {currentPage === 10 && (

                    <div>


                        {/* ==========================================
        PAGE HEADER
========================================== */}


                        <h1 className="receipt-title">

                            PRE-FLASH TOWER

                        </h1>


                        <h2 className="receipt-subtitle">

                            LABORATORY INTERPRETATION & OPERATOR REPORT

                        </h2>


                        <hr />






                        {/* ==========================================
        OVERALL ASSESSMENT
========================================== */}


                        <h3 className="section-title">

                            OVERALL PROCESS ASSESSMENT

                        </h3>



                        <table className="receipt-table">


                            <tbody>



                                <tr>

                                    <td>
                                        Equipment
                                    </td>


                                    <td>
                                        Pre-Flash Tower
                                    </td>


                                </tr>



                                <tr>

                                    <td>
                                        Service
                                    </td>


                                    <td>
                                        Crude Partial Vaporization / Light End Recovery
                                    </td>


                                </tr>




                                <tr>

                                    <td>
                                        Feed Status
                                    </td>


                                    <td>

                                        {

                                            TotalFeed > 0

                                                ?

                                                "FEED AVAILABLE"

                                                :

                                                "NO FEED"

                                        }

                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        Separation Condition
                                    </td>


                                    <td>


                                        {

                                            vaporFraction > 0.05

                                                ?

                                                "ACTIVE FLASHING"

                                                :

                                                "LOW FLASHING"

                                        }


                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        Material Balance

                                    </td>


                                    <td>


                                        {

                                            (
                                                (
                                                    FIC_16009 +
                                                    FIC_16013
                                                )

                                                /

                                                TotalFeed

                                                *

                                                100

                                            )

                                                .toFixed(2)

                                        }

                                        %

                                    </td>


                                </tr>




                            </tbody>


                        </table>







                        <br />






                        {/* ==========================================
        KEY OBSERVATIONS
========================================== */}



                        <h3 className="section-title">

                            LABORATORY OBSERVATIONS

                        </h3>




                        <div

                            style={{

                                padding: "15px",

                                border: "1px solid #bbb",

                                borderRadius: "8px",

                                lineHeight: "1.6"

                            }}

                        >


                            <ul>


                                <li>

                                    The crude feed entering the Pre-Flash Tower is a blended
                                    light sweet crude stream with controlled vaporization
                                    characteristics.

                                </li>



                                <li>

                                    The tower is preferentially removing light hydrocarbons,
                                    mainly Light Naphtha and part of Heavy Naphtha components.

                                </li>



                                <li>

                                    Heavy hydrocarbon fractions including Diesel, VGO and
                                    Atmospheric Residue remain predominantly in the bottoms
                                    stream.

                                </li>



                                <li>

                                    The temperature profile indicates progressive reduction of
                                    temperature from bottom section towards overhead section,
                                    confirming normal fractionation behaviour.

                                </li>



                                <li>

                                    The material balance closure indicates acceptable process
                                    calculation consistency.

                                </li>


                            </ul>


                        </div>







                        <br />







                        {/* ==========================================
        RECOMMENDATIONS
========================================== */}



                        <h3 className="section-title">

                            PROCESS RECOMMENDATIONS

                        </h3>





                        <table className="receipt-table">


                            <thead>

                                <tr>

                                    <th>
                                        Parameter
                                    </th>

                                    <th>
                                        Recommendation
                                    </th>

                                </tr>


                            </thead>



                            <tbody>




                                <tr>

                                    <td>
                                        Feed Temperature
                                    </td>


                                    <td>

                                        Maintain sufficient temperature above initial boiling point
                                        to achieve desired flashing without excessive vapor losses.

                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        Reflux Operation
                                    </td>


                                    <td>

                                        Optimize reflux flow to balance light-end recovery and
                                        overhead condensation.

                                    </td>


                                </tr>






                                <tr>

                                    <td>
                                        Stripping Water

                                    </td>


                                    <td>

                                        Maintain controlled injection rate to improve light-end
                                        removal and prevent excessive hydrocarbon carryover.

                                    </td>


                                </tr>






                                <tr>

                                    <td>
                                        Tower Pressure

                                    </td>


                                    <td>

                                        Monitor pressure stability to avoid changes in vaporization
                                        severity.

                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        Bottom Product Quality

                                    </td>


                                    <td>

                                        Monitor heavy hydrocarbon retention and downstream furnace
                                        feed quality.

                                    </td>


                                </tr>




                            </tbody>


                        </table>









                        <br />







                        {/* ==========================================
        OPERATOR MONITORING
========================================== */}



                        <h3 className="section-title">

                            CONTROL ROOM MONITORING POINTS

                        </h3>





                        <table className="receipt-table">


                            <thead>


                                <tr>

                                    <th>
                                        Tag
                                    </th>

                                    <th>
                                        Description
                                    </th>

                                    <th>
                                        Action

                                    </th>


                                </tr>


                            </thead>




                            <tbody>




                                <tr>

                                    <td>
                                        TT-16001
                                    </td>


                                    <td>
                                        Pre-Flash Feed Temperature
                                    </td>


                                    <td>
                                        Monitor vaporization severity
                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        PT-16001
                                    </td>


                                    <td>
                                        Tower Feed Pressure
                                    </td>


                                    <td>
                                        Maintain stable operation
                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        TT-16002 / TT-16003 / TT-16004
                                    </td>


                                    <td>
                                        Tower Temperature Profile
                                    </td>


                                    <td>
                                        Confirm separation behaviour
                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        FIC-16009
                                    </td>


                                    <td>
                                        Overhead Vapor Flow
                                    </td>


                                    <td>
                                        Monitor light-end recovery
                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        FIC-16013
                                    </td>


                                    <td>
                                        Bottom Product Flow
                                    </td>


                                    <td>
                                        Confirm downstream feed availability
                                    </td>


                                </tr>




                            </tbody>


                        </table>







                        <br />








                        {/* ==========================================
        FINAL CONCLUSION
========================================== */}



                        <h3 className="section-title">

                            FINAL LABORATORY CONCLUSION

                        </h3>




                        <div

                            style={{

                                padding: "18px",

                                background: "#f4f4f4",

                                border: "1px solid #999",

                                borderRadius: "8px",

                                fontSize: "14px",

                                lineHeight: "1.7"

                            }}

                        >


                            <strong>

                                PROCESS ENGINEERING CONCLUSION:

                            </strong>


                            <p>


                                Based on the simulated laboratory analysis, the Pre-Flash
                                Tower is operating within expected process behaviour.
                                The crude feed undergoes controlled vapor-liquid separation
                                with light hydrocarbons recovered overhead while maintaining
                                heavy hydrocarbon recovery in the bottoms stream.


                            </p>



                            <p>


                                Continuous monitoring of feed temperature, tower pressure,
                                reflux performance and product flow is recommended to ensure
                                stable operation and optimum crude processing efficiency.

                            </p>



                        </div>








                        <br />






                        {/* ==========================================
        SIGNATURE SECTION
========================================== */}



                        <table className="receipt-table">


                            <tbody>


                                <tr>


                                    <td>

                                        Prepared By:

                                        <br />

                                        Process Laboratory System

                                    </td>


                                    <td>

                                        Reviewed By:

                                        <br />

                                        Process Engineering Department

                                    </td>


                                </tr>



                                <tr>


                                    <td>

                                        Date:

                                        <br />

                                        {new Date().toLocaleDateString()}

                                    </td>



                                    <td>

                                        Status:

                                        <br />

                                        SIMULATION / DIGITAL TWIN REPORT

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                )}



                {currentPage === 11 && (

                    <div>


                        {/* ==========================================
        PAGE HEADER
========================================== */}


                        <h1 className="receipt-title">

                            PRE-FLASH TOWER

                        </h1>


                        <h2 className="receipt-subtitle">

                            FINAL LABORATORY SUMMARY & CERTIFICATION

                        </h2>


                        <hr />






                        {/* ==========================================
        EXECUTIVE SUMMARY
========================================== */}


                        <h3 className="section-title">

                            EXECUTIVE SUMMARY

                        </h3>




                        <div

                            style={{

                                padding: "18px",

                                border: "1px solid #999",

                                borderRadius: "8px",

                                lineHeight: "1.7",

                                background: "#fafafa"

                            }}

                        >


                            <p>


                                This laboratory report presents the simulated process
                                analysis of the Pre-Flash Tower crude separation system.
                                The analysis evaluates crude feed characteristics,
                                operating conditions, vapor-liquid separation performance,
                                and resulting overhead and bottoms product quality.


                            </p>



                            <p>


                                The Pre-Flash Tower receives blended crude from the
                                refinery day tank and performs controlled partial
                                vaporization to recover light hydrocarbon components
                                while maintaining heavier hydrocarbon fractions for
                                downstream atmospheric distillation processing.


                            </p>



                        </div>








                        <br />







                        {/* ==========================================
        KEY PROCESS VALUES
========================================== */}



                        <h3 className="section-title">

                            KEY PROCESS PERFORMANCE VALUES

                        </h3>




                        <table className="receipt-table">


                            <thead>


                                <tr>

                                    <th>
                                        Parameter
                                    </th>

                                    <th>
                                        Value
                                    </th>

                                    <th>
                                        Unit
                                    </th>

                                </tr>


                            </thead>




                            <tbody>




                                <tr>

                                    <td>
                                        Total Feed Rate
                                    </td>


                                    <td>

                                        {

                                            Number(
                                                TotalFeed || 0

                                            )

                                                .toFixed(3)

                                        }

                                    </td>


                                    <td>
                                        BPM
                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        Overhead Vapor Recovery
                                    </td>


                                    <td>

                                        {

                                            Number(

                                                FIC_16009 || 0

                                            )

                                                .toFixed(3)

                                        }

                                    </td>


                                    <td>
                                        BPM
                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        Bottom Product Recovery
                                    </td>


                                    <td>

                                        {

                                            Number(

                                                FIC_16013 || 0

                                            )

                                                .toFixed(3)

                                        }

                                    </td>


                                    <td>
                                        BPM
                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        Vapor Fraction
                                    </td>


                                    <td>

                                        {

                                            (
                                                vaporFraction *
                                                100

                                            ).toFixed(2)

                                        }

                                    </td>


                                    <td>
                                        %
                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        Material Balance Closure
                                    </td>


                                    <td>

                                        {

                                            TotalFeed > 0

                                                ?

                                                (

                                                    (
                                                        FIC_16009 +
                                                        FIC_16013

                                                    )

                                                    /

                                                    TotalFeed

                                                    *

                                                    100

                                                )

                                                    .toFixed(2)

                                                :

                                                100

                                        }

                                    </td>


                                    <td>
                                        %
                                    </td>


                                </tr>





                            </tbody>


                        </table>









                        <br />








                        {/* ==========================================
        PRODUCT RECOVERY SUMMARY
========================================== */}



                        <h3 className="section-title">

                            PRODUCT RECOVERY SUMMARY

                        </h3>




                        <table className="receipt-table">


                            <thead>


                                <tr>

                                    <th>
                                        Stream
                                    </th>

                                    <th>
                                        Main Components
                                    </th>

                                    <th>
                                        Destination
                                    </th>


                                </tr>


                            </thead>




                            <tbody>




                                <tr>


                                    <td>
                                        Pre-Flash Overhead

                                    </td>


                                    <td>

                                        Light Naphtha,
                                        Heavy Naphtha,
                                        Minor Kerosene

                                    </td>


                                    <td>

                                        Overhead Condensation System

                                    </td>


                                </tr>






                                <tr>


                                    <td>
                                        Pre-Flash Bottoms

                                    </td>


                                    <td>

                                        Heavy Naphtha,
                                        Kerosene,
                                        Diesel,
                                        VGO,
                                        Residue

                                    </td>


                                    <td>

                                        Atmospheric Furnace Feed

                                    </td>


                                </tr>





                            </tbody>


                        </table>









                        <br />








                        {/* ==========================================
        CERTIFICATION
========================================== */}



                        <h3 className="section-title">

                            LABORATORY CERTIFICATION

                        </h3>




                        <table className="receipt-table">


                            <tbody>




                                <tr>

                                    <td>
                                        Report Identification
                                    </td>


                                    <td>

                                        {

                                            report.reportNumber

                                        }

                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        Generated Date

                                    </td>


                                    <td>

                                        {

                                            report.generated

                                        }

                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        Equipment Evaluated

                                    </td>


                                    <td>

                                        Pre-Flash Tower

                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        Analysis Type

                                    </td>


                                    <td>

                                        Digital Twin Process Laboratory Simulation

                                    </td>


                                </tr>





                                <tr>

                                    <td>
                                        Report Status

                                    </td>


                                    <td>

                                        COMPLETED

                                    </td>


                                </tr>




                            </tbody>


                        </table>









                        <br />







                        {/* ==========================================
        DISCLAIMER
========================================== */}



                        <h3 className="section-title">

                            DIGITAL TWIN DISCLAIMER

                        </h3>





                        <div

                            style={{

                                padding: "18px",

                                border: "1px solid #aaa",

                                borderRadius: "8px",

                                fontSize: "13px",

                                lineHeight: "1.7"

                            }}

                        >


                            <strong>

                                IMPORTANT NOTICE:

                            </strong>



                            <p>


                                This laboratory report is generated by the NK Refinery
                                Digital Twin System for process simulation, operator
                                training, engineering analysis and educational purposes.


                            </p>




                            <p>


                                The values presented represent calculated process
                                conditions based on the configured refinery simulation
                                model and should not be considered as replacement for
                                actual plant laboratory measurements, operating data,
                                or certified engineering documents.


                            </p>



                            <p>


                                Actual refinery operation must always be verified using
                                approved process instrumentation, laboratory analysis,
                                and operational procedures.

                            </p>



                        </div>









                        <br />









                        {/* ==========================================
        APPROVAL SECTION
========================================== */}



                        <table className="receipt-table">


                            <tbody>



                                <tr>


                                    <td>


                                        Prepared By:

                                        <br /><br />


                                        NK Refinery Digital Twin

                                        <br />

                                        Process Simulation Laboratory


                                    </td>





                                    <td>


                                        Approved By:

                                        <br /><br />


                                        Process Engineering Department

                                        <br />

                                        Operations Department


                                    </td>



                                </tr>




                                <tr>


                                    <td>


                                        Electronic Signature:

                                        <br />

                                        ____________________


                                    </td>




                                    <td>


                                        Date:

                                        <br />

                                        {new Date().toLocaleDateString()}

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                )}




                <hr />

                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: 25
                    }}
                >

                    <button
                        className="receipt-button"
                        disabled={currentPage === 0}
                        onClick={() => setCurrentPage(p => p - 1)}
                    >
                        ◀ Previous
                    </button>

                    <strong>
                        Page {currentPage + 1} of 12
                    </strong>

                    <button
                        className="receipt-button"
                        disabled={currentPage === 11}
                        onClick={() => setCurrentPage(p => p + 1)}
                    >
                        Next ▶
                    </button>

                </div>

                <br />

                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 20
                    }}
                >

                    <button
                        className="receipt-button"
                        onClick={() => window.print()}
                    >
                        Print
                    </button>

                    <button
                        className="receipt-button"
                    >
                        Export PDF
                    </button>

                    <button
                        className="receipt-button"
                        onClick={onClose}
                    >
                        Close
                    </button>

                </div>

            </div>

        </div>


    )

};

export default PreFlashLaboratory;